/**
 * 救援服务单详情页面
 * 创建时间：2017-07-21
 * 创建人：zhan
 * 修改人：sun shujuan
 1）删除、撤单、改变派单方式、保存、重新派单请求成功后，关闭当前tab,并刷新一览列表
 2）只有代救援-人工派单且不是新建状态时,且不是救援公司,且不是从历史救援或司机救援单跳过来时才可以删除
 3）只有新建和已撤单、已完成时不显示撤单
 4) 救援状态为“已撤单”时，除了撤单原因和详情，救援单不允许再编辑（按钮不可点击）
 5）救援状态为“已完成”时，救援单不允许再编辑。
 6）救援公司对救援单详情只允许有“查看”权限，当救援公司操作员点击“详情”查看救援单详情时，救援单详情中的所有按钮均不允许点击。（查看救援轨迹、地图除外）	levv==3
 */
<template>
	<div class="float-e-margins ibox-content ibox_main tabBox" :id="'rescueserviceorder-edit' + dataInfo.id" ref="rescueserviceorder">
		<ul class="col-sm-12 pl0px pt0px grey_box02">
			<li  @click="changePage(0)" class="w100px t_center" :class="{active:curPage === 0}">
				<a>基本信息</a>
			</li>
			<li  @click="changePage(1)" class="w100px t_center" :class="{active:curPage === 1}">
				<a>派单详情</a>
			</li>
		</ul>
		<div v-show="curPage==0" class="grey_box" >
			<div v-loading="loadingorder" element-loading-text="加载中" style="height:100%;">
				<div class="form-horizontal">
					<div class="form-group">
						<label class="col-sm-1 control-label">救援进度</label>
						<div class="col-sm-11 control-label t_left" v-if="!isDetailMode">
							<span ><a>新建救援单</a></span>
						</div>
						<div class="col-sm-11 control-label t_left" v-if="isDetailMode" :style="statusDetail">
							<!--待救援-自动派单或已拒单且派单类型为2时-->
							<span v-if="dataInfo.rescueStage==11 || ((dataInfo.rescueStage == 53 || dataInfo.rescueStage == 51 || dataInfo.rescueStage == 52) && dataInfo.dispatchType==2)">
								救援单建立完成 >> <a>自动派单中</a>
								<button class="btn btn-primary ml20px" v-show="dataInfo.rescueStatus == 1 || dataInfo.rescueStatus == 2" @click='changeRescue'>变更救援类型</button>
								<button class="btn btn-primary ml20px" @click="dispatchChange(12)" v-if="levv!=3 && permission.indexOf('rescueServiceOrderList_changeType') == -1">改人工派单</button>
								<button class="btn btn-primary ml20px" v-if="levv!=3 && permission.indexOf('rescueServiceOrderList_changeToRescueCompany') == -1" @click="dispatchToCompany">向救援公司派单</button>
								<span class="ml20px" v-if="levv!=3">{{dataInfo.dispatch2CompanyNote}}</span>
							</span>
							<!--待救援-人工派单或已拒单且派单类型为1时-->
							<span v-if="dataInfo.rescueStage==13 || dataInfo.rescueStage==12 || ((dataInfo.rescueStage == 53 || dataInfo.rescueStage == 51 || dataInfo.rescueStage == 52) && dataInfo.dispatchType==1) ">
								救援单建立完成 >> <a>待人工派单</a>
								<button class="btn btn-primary ml20px" v-show="dataInfo.rescueStatus == 1 || dataInfo.rescueStatus == 2" @click='changeRescue'>变更救援类型</button>
								<button class="btn btn-primary ml20px" @click="dispatchChange(11)" v-if="levv!=3 && permission.indexOf('rescueServiceOrderList_changeType') == -1 && dateType==0 ">改自动派单</button>
								<button class="btn btn-primary ml20px" v-if="levv!=3 && permission.indexOf('rescueServiceOrderList_changeToRescueCompany') == -1" @click="dispatchToCompany">向救援公司派单</button>
								<span class="ml20px" v-if="levv!=3">{{dataInfo.dispatch2CompanyNote}}</span>
							</span>
							<span v-if="dataInfo.rescueStage==21">
								救援单建立完成 >> {{dataInfo.dispatchType=='2'?'自动':'人工'}}派单完成  <a>>> 救援车前往现场中</a>
								<button class="btn btn-primary ml20px" v-show="dataInfo.rescueStatus == 1 || dataInfo.rescueStatus == 2" @click='changeRescue'>变更救援类型</button>
								<button class="btn btn-primary ml20px" v-show="dataInfo.rescueStatus == 2" @click='changescheduling'>内部调度</button>
								<button class="btn btn-primary ml20px" @click="reDispatch" v-if="permission.indexOf('rescueServiceOrderList_changeType') == -1">取消重新派单</button>&nbsp;
								<button class="btn btn-primary" @click="checkPos">查看救援车位置</button>
							</span>
							<span v-if="dataInfo.rescueStage==23">救援单建立完成 >> {{dataInfo.dispatchType=='2'?'自动':'人工'}}派单完成  <a>>> 救援车已到现场</a>
								<button class="btn btn-primary ml20px" v-show="dataInfo.rescueStatus == 1 || dataInfo.rescueStatus == 2" @click='changeRescue'>变更救援类型</button>
								<button class="btn btn-primary ml20px" v-show="dataInfo.rescueStatus == 2" @click='changescheduling'>内部调度</button>
								<button class="btn btn-primary ml20px" @click="checkPos">查看救援车位置</button>
							</span>
							<!--司机已完成或已撤单时-->
							<span v-if="dataInfo.rescueStage==31 || dataInfo.rescueStage==41 || dataInfo.rescueStage==42 || dataInfo.rescueStage==43">救援单建立完成 >> {{dataInfo.dispatchType=='2'?'自动':'人工'}}派单完成  <a>>> 救援车作业完成</a></span>
							<span v-if="dataInfo.rescueStage==32">救援单建立完成 >> {{dataInfo.dispatchType=='2'?'自动':'人工'}}派单完成  <a>>> 救援车作业完成 >> 客户已评价</a></span>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-1 control-label">救援单号</label>
						<div class="col-sm-3">
							<input type="text" class="form-control" v-model="dataInfo.id" readonly>
						</div>
						<label class="col-sm-1 control-label red">*时间类型</label>
						<div class="col-sm-3" v-bind:class="{'form-group--error': $v.dataInfo.dateType.$error }">
							<select class="form-control" v-model.trim="dataInfo.dateType" :disabled="dataInfo.rescueStatus!=1 || (isDetailMode && levv==3)">
								<option :value="dateType.udccode" v-for="dateType in dateTypeList">{{dateType.udcname}}</option>
							</select>
							<span class="cus_message form-group__message" v-if="!$v.dataInfo.dateType.required && $v.dataInfo.dateType.$error">时间类型为必填项</span>
						</div>
						<!--如果是新建，请求时间默认为当前时间。从预约切换到实时类型，需要更新请求时间。-->
						<!--非预约单，待救援状态下切换成预约单，预约时间可以修改，其他情况都是请求时间，数值从后台拉取且不可修改-->
						<!--预约单，新建完成后预约时间不能修改，切换成实时后，显示请求时间，默认当前时间-->
						<label class="col-sm-1 control-label red" v-show="dataInfo.dateType==realTimeCode">*请求时间</label>
						<div class="col-sm-3" v-bind:class="{'form-group--error': $v.dataInfo.requestTime.$error }" v-show="dataInfo.dateType==realTimeCode">
							<input v-model.trim="dataInfo.requestTime" ref="requestDate" @input="$v.dataInfo.requestTime.$touch()" class="form-control" disabled />
							<span class="cus_message form-group__message" v-if="!$v.dataInfo.requestTime.required && $v.dataInfo.requestTime.$error">请求时间为必填项</span>
						</div>
						<label class="col-sm-1 control-label red" v-show="dataInfo.dateType==1">*预约时间</label>
						<div class="col-sm-3" v-bind:class="{'form-group--error': $v.dataInfo.requestTime.$error }" v-show="dataInfo.dateType==1">
							<!--<datepicker v-model.trim="dataInfo.requestTime" ref="requestDate" :options="localeOption" @input="$v.dataInfo.requestTime.$touch()" class="form-control" :isDisabled = "dataInfo.rescueStatus!==1 || (dataInfo.rescueStatus==1 && this.dateType==1) || (isDetailMode && levv==3)" ></datepicker>-->
							 <!--新建后不可修改,待救援状态时，非预约单切换成预约单时可以编辑   this.dateType==1代表预约单-->
							<input v-if="(isDetailMode && (dataInfo.rescueStatus!==1 || (dataInfo.rescueStatus==1 && dateType==1))) || (isDetailMode && levv==3)" v-model.trim="dataInfo.requestTime" ref="requestDate" @input="$v.dataInfo.requestTime.$touch()" class="form-control" disabled />
							<datepicker v-else v-model.trim="dataInfo.requestTime" ref="requestDate" :options="localeOption" @input="$v.dataInfo.requestTime.$touch()" class="form-control"></datepicker>
							<span class="cus_message form-group__message" v-if="!$v.dataInfo.requestTime.required && $v.dataInfo.requestTime.$error">预约时间为必填项</span>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-1 control-label red">*救援状态</label>
						<!--新建时允许下拉，实时类型的默认待救援-自动派单中,预约类型的只能是待救援-人工派单-->
						<div class="col-sm-3"  v-bind:class="{'form-group--error': $v.dataInfo.rescueStage.$error }" v-if="!isDetailMode">
							<select class="form-control"  v-model.trim="dataInfo.rescueStage"  @change="$v.dataInfo.rescueStage.$touch()" v-show="dataInfo.dateType==realTimeCode">
								<option value="11">待救援-自动派单</option>
								<option value="12">待救援-人工派单</option>
							</select>
							<select class="form-control"  v-model.trim="dataInfo.rescueStage"  @change="$v.dataInfo.rescueStage.$touch()" v-show="dataInfo.dateType==1">
								<option value="12">待救援-人工派单</option>
							</select>
							<span class="cus_message form-group__message" v-if="!$v.dataInfo.rescueStage.required && $v.dataInfo.rescueStage.$error">救援状态为必填项</span>
						</div>
						<!--新建完成时，实时类型的救援状态不允许编辑，预约类型的且待救援状态的需要默认改为人工派单-->
						<div class="col-sm-3" v-else>
							<!-- <select class="form-control" v-show="dataInfo.rescueStatus==1 && dataInfo.dateType==1" disabled>
								 <option value="12">待救援-人工派单</option>
							</select> -->
							<!-- v-show="!(dataInfo.rescueStatus==1 && dataInfo.dateType==1)" -->
							<select class="form-control"  v-model.trim="dataInfo.rescueStage" disabled>
								 <option v-for="stage in rescueStageList" :value="stage.udccode">{{dataInfo.rescueStatusName + '-' + stage.udcname}}</option>
							</select>
						</div>
						<label class="col-sm-1 control-label red">*救援类型</label>
						<!--待救援以外都不可编辑-->
						<div class="col-sm-3" v-bind:class="{'form-group--error': $v.dataInfo.rescueType.$error }">
							<div class="col-sm-3 control-label t_left" v-for="type in rescueTypeList" :key='type.udccode'> 
								<input type="radio" :value="type.udccode" v-model="dataInfo.rescueType" :disabled="dataInfo.rescueStatus!=1 || levv==3"/>
								<span>{{type.udcname}}</span>
							</div>
							<span class="cus_message form-group__message" v-if="!$v.dataInfo.rescueType.required && $v.dataInfo.rescueType.$error">救援类型为必填项</span>
						</div>
					</div>
                    <div class="form-group">
                        <label for="" class="col-sm-1 control-label red">*坐席号:</label>
                        <div class="col-sm-3" :class="{'form-group--error': $v.dataInfo.employeeNo.$error }">
                            <input type="text" class="form-control"
                            @input="$v.dataInfo.employeeNo.$touch()" v-model="dataInfo.employeeNo" >
                            <span class="cus_message form-group__message" v-if="!$v.dataInfo.employeeNo.required && $v.dataInfo.employeeNo.$error">坐席为必填项</span>
                        </div>
                        <label for="" class="col-sm-1 control-label red">*不使用微信原因:</label>
                        <div class="col-sm-3" :class="{'form-group--error': $v.dataInfo.wechatOrderCause.$error }">
                            <select class="form-control" v-model="dataInfo.wechatOrderCause">
                                <option value="1" >注册错误</option>
                                <option value="2" >拒绝微信下单</option>
                            </select>
                            <span class="cus_message form-group__message" v-if="!$v.dataInfo.wechatOrderCause.required && $v.dataInfo.wechatOrderCause.$error">不使用微信原因为必填项</span>
                        </div>
                        <label v-if="isDetailMode" class="col-sm-1 control-label">服务单来源:</label>
                        <div class="col-sm-3" v-if="isDetailMode">
                            <input type="text" class="form-control"
                             v-model="dataInfo.certificatesTypeString" readonly>
                        </div>
                    </div>
					<div class="form-group">
						<label class="col-sm-1 control-label red" v-if="dataInfo.rescueStatus==4">*撤单原因</label>
						<div class="col-sm-3" v-if="dataInfo.rescueStatus==4" v-bind:class="{'form-group--error': $v.dataInfo.cancelStatus.$error }">
							<select class="form-control" v-model.trim="dataInfo.cancelStatus" @change="$v.dataInfo.cancelStatus.$touch()" :disabled="dataInfo.rescueStatus==3 || (isDetailMode && levv==3)">
								<option value="41">客户主动取消</option>
								<option value="42">未能找到现场</option>
								<option value="43">救援录入重复</option>
							</select>
							<span class="cus_message form-group__message" v-if="dataInfo.rescueStatus==4 && !$v.dataInfo.cancelStatus.required && $v.dataInfo.cancelStatus.$error">撤单原因为必填项</span>
						</div>
						<label class="col-sm-1 control-label red" v-if="dataInfo.rescueStatus==4">*原因详情</label>
						<div class="col-sm-7" v-if="dataInfo.rescueStatus==4" v-bind:class="{'form-group--error': $v.dataInfo.cancelReason.$error }">
							<input type="text" class="form-control" v-model.trim="dataInfo.cancelReason"  @input="$v.dataInfo.cancelReason.$touch()" :disabled="dataInfo.rescueStatus==3 || (isDetailMode && levv==3)">
							<span class="cus_message form-group__message" v-if="dataInfo.rescueStatus==4 && !$v.dataInfo.cancelReason.required && $v.dataInfo.cancelReason.$error">原因详情为必填项</span>
						</div>
					</div>
				</div>
				<div class="form-horizontal mt20px">
					<div class="form-group text-left">
						<label class="col-sm-6  control-label t_left">被救援人信息</label>
					</div>
				</div>
				<div class="form-horizontal ibox-content mt20px">
					<br />
          <div class="form-group" v-if="parseInt(dataInfo.rescueTimes) >= 0">
            <label class="col-sm-1 control-label">已用救援次数</label>
            <div class="col-sm-3">
              <input type="text" class="form-control" v-model="dataInfo.rescueTimes" disabled>
            </div>
          </div>
					<div class="form-group">
						<label class="col-sm-1 control-label red">*车牌号</label>
						<div class="col-sm-3"  v-bind:class="{'form-group--error': $v.dataInfo.rescuedPlateNumber.$error }">
							<input type="text" class="form-control" v-model.trim="dataInfo.rescuedPlateNumber"  @keyup="setUpperCase" @blur="isPlateNumberOk" @input="$v.dataInfo.rescuedPlateNumber.$touch()" maxLength="8" :disabled="dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4 || (isDetailMode && levv==3)">
							<span class="cus_message form-group__message" v-if="!$v.dataInfo.rescuedPlateNumber.required && $v.dataInfo.rescuedPlateNumber.$error">该车牌号为必填项</span>
						</div>
						<label class="col-sm-1 control-label">车型</label>
						<div class="col-sm-3">
							<input type="text" class="form-control" v-model.trim="dataInfo.rescuedModel" :disabled="dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4 || (isDetailMode && levv==3)">
						</div>
						<label class="col-sm-1 control-label">颜色</label>
						<div class="col-sm-3">
							<input type="text" class="form-control"  v-model.trim="dataInfo.rescuedColor" :disabled="dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4 || (isDetailMode && levv==3)" />
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-1 control-label">车主姓名</label>
						<div class="col-sm-3">
							<input type="text" class="form-control" v-model.trim="dataInfo.rescuedName" :disabled="dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4 || (isDetailMode && levv==3)">
						</div>
						<label class="col-sm-1 control-label red">*手机号</label>
						<div class="col-sm-3"  v-bind:class="{'form-group--error': $v.dataInfo.rescuedPhone.$error }">
							<input type="text" class="form-control" v-model.trim="dataInfo.rescuedPhone"  @input="$v.dataInfo.rescuedPhone.$touch()" :disabled="dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4 || (isDetailMode && levv==3)" maxlength="11">
							<span class="cus_message form-group__message" v-if="!$v.dataInfo.rescuedPhone.required && $v.dataInfo.rescuedPhone.$error">手机号为必填项</span>
							<span class="cus_message form-group__message" v-if="!phoneSet">请输入有效手机号</span>
						</div>
                        <label for="" class="col-sm-1 control-label">身份证号</label>
                        <div class="col-sm-3" >
                            <input type="text" class="form-control"  v-bind:class="{'form-group--error': $v.dataInfo.rescuedPlateNumber.$error }"
                            @input="$v.dataInfo.identifyNo.$touch()" v-model="dataInfo.identifyNo" >
                            <!-- <span class="cus_message form-group__message" v-if="!$v.dataInfo.identifyNo.required && $v.dataInfo.identifyNo.$error">身份证号为必填项</span> -->
							            <span class="cus_message form-group__message" v-if="!checkCertificatesNoC">请输入有效身份证号</span>
                        </div>
					</div>
					<div >
						<baidu-map
							:center="mapCenter"
							:zoom="mapZoom"
							:scroll-wheel-zoom="enableScroll"
							@ready="ready">
						</baidu-map>
					</div>
					<div class="form-group">
						<label class="col-sm-1 control-label red">*救援地址</label>
						<div class="col-sm-5"  v-bind:class="{'form-group--error': $v.dataInfo.rescuedAddress.$error }">
							<!--“救援状态”为“已完成”时，定位不允许再更改。-->
							<input type="text" class="form-control" :id="[isDetailMode?'srchInputRescue'+dataInfo.id:'newSrchInputRescue']" size="20" placeholder="请输入地址" v-model.trim="dataInfo.rescuedAddress" @focus.once="searchRescueAdds" @input="$v.dataInfo.rescuedAddress.$touch()" :disabled="dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4 || (isDetailMode && levv==3)" />
							<div :id="[isDetailMode?'srchPanelRescue'+dataInfo.id:'newSrchPanelRescue']" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
							<span class="cus_message form-group__message" v-if="!$v.dataInfo.rescuedAddress.required && $v.dataInfo.rescuedAddress.$error">救援地址为必填项</span>
						</div>
						<label class="col-sm-1 control-label">详细地址</label>
						<div class="col-sm-4">
							<input type="text" class="form-control" v-model="dataInfo.rescuedAddressDetail" :disabled="dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4 || (isDetailMode && levv==3)"/>
						</div>
						<div class="col-sm-1">
							<button @click="openMapTab(dataInfo.rescuedPoints,dataInfo.rescuedAddress,1)" class="btn btn-primary white" :disabled="dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4 || !dataInfo.rescuedPoints" v-loading="!(dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4) && loadingBtn1">地图</button>
						</div>
					</div>
					<!--只有拖车时才显示目的地址-->
					<div class="form-group" v-if="dataInfo.rescueType==1 || dataInfo.rescueType==4">
						<label class="col-sm-1 control-label">目的地址</label>
						<div class="col-sm-5">
							<input type="text" class="form-control" :id="[isDetailMode?'srchInputDest'+dataInfo.id:'newSrchInputDest']" size="20" :placeholder="dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4 || (isDetailMode && levv==3)?'':'请输入地址'" @focus.once="searchDestAdds" v-model.trim="dataInfo.destAddress" :disabled="dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4 || (isDetailMode && levv==3)"/>
							<div :id="[isDetailMode?'srchPanelDest'+dataInfo.id:'newSrchPanelDest']" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
						</div>
						<label class="col-sm-1 control-label">目的详细</label>
						<div class="col-sm-4">
							<input type="text" class="form-control" v-model="dataInfo.destAddressDetail" :disabled="dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4 || (isDetailMode && levv==3)" />
						</div>
						<div class="col-sm-1">
						    <button @click="openMapTab(dataInfo.destPoints,dataInfo.destAddress,2)" class="btn btn-primary white" :disabled="dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4 || !dataInfo.destPoints" v-loading="!(dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4) && loadingBtn2">地图</button>
						</div>
					</div>
					<div class="form-group">
            <label class="col-sm-1 control-label red">*保单号</label>
            <div class="col-sm-5"  v-bind:class="{'form-group--error': $v.dataInfo.policyNo.$error }">
              <input type="text" class="form-control" v-model.trim="dataInfo.policyNo" maxLength="22" @blur="checkPoliceNoPost" :disabled="dataInfo.rescueStatus==3 || dataInfo.rescueStatus==4 || (isDetailMode && levv==3)">
              <span class="cus_message form-group__message" v-if="!$v.dataInfo.policyNo.required && $v.dataInfo.policyNo.$error">保单号为必填项</span>
              <span class="cus_message form-group__message" v-if="!checkPolicyNo">请输入有效的保单号</span>
            </div>
						<label class="col-sm-1 control-label">备注</label>
						<div class="col-sm-5" v-bind:class="{'form-group--error': $v.dataInfo.rescuedMemo.$error }">
							<textarea type="text" class="form-control" v-model.trim="dataInfo.rescuedMemo" maxlength="254" :readonly="isDetailMode && levv==3"></textarea>
							<span class="cus_message form-group__message" v-if="!$v.dataInfo.rescuedMemo.maxLength && $v.dataInfo.rescuedMemo.$error">备注输入过长</span>
						</div>
					</div>
				</div>
				<div class="form-horizontal mt20px">
					<div class="form-group text-left col-sm-12">
						<label  style="float:left; padding-left:1px;">救援信息</label>
						<button class="btn btn-primary" style="float:right;" @click="goRescueTrack" v-if="dataInfo.rescueStatus == 3">查看救援轨迹</button>
					</div>
				</div>
				<div class="form-horizontal ibox-content mt20px">
					<br />
					<div class="form-group">
						<label class="col-sm-1 control-label">车牌号</label>
						<div class="col-sm-3">
							<input type="text" class="form-control"  v-model.trim="dataInfo.plateNumber" maxlength="8" readonly/>
						</div>
						<label class="col-sm-1 control-label">派单时间</label>
						<div class="col-sm-3">
							<input type="text" v-model.trim="dataInfo.dispatchTime" readonly  class="form-control"/>
							<!--<datepicker v-model.trim="dataInfo.dispatchTime" :options="localeOption" :isDisabled="isDetailMode || !isDetailMode" class="form-control"></datepicker>-->
						</div>
						<label class="col-sm-1 control-label">救援公司</label>
						<div class="col-sm-3">
							<input type="text" class="form-control"  v-model="dataInfo.customerName" readonly>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-1 control-label">司机</label>
						<div class="col-sm-3">
							<input type="text" class="form-control"  v-model="dataInfo.driverName" readonly>
						</div>
						<label class="col-sm-1 control-label">司机电话</label>
						<div class="col-sm-3">
							<input type="text" class="form-control"  v-model="dataInfo.driverPhone" readonly>
						</div>
						<label v-show='dataInfo.requestCode' class="col-sm-1 control-label">审核结果</label>
						<div v-show='dataInfo.requestCode' class="col-sm-3">
							<input type="text" class="form-control"  v-model="dataInfo.platformAuditStatusStr" readonly>
						</div>
					</div>
					<div class="form-group" v-show='dataInfo.requestCode'>
						<label class="col-sm-1 control-label">审核备注</label>
						<div class="col-sm-3">
							<textarea class="form-control" v-model="dataInfo.failRemark" style="resize:none" readonly rows="3" cols="3"></textarea>
						</div>
					</div>
					<rescue-order-pics
						v-if="dataInfo.photos"
						:picUrl="picUrl"
						:picUrl2="picUrl2"
						:orderId='rid'
						:id="'#rescueserviceorder-edit' +dataInfo.id"
						:photos="dataInfo.photos"
						:requestCode='dataInfo.requestCode'
						:reqstate='dataInfo.platformAuditStatus'
						@refreshinfo='refinfo'
						>
					</rescue-order-pics>
					<!--<div class="form-group">
							<label class="col-sm-1 control-label">现场照片</label>
							<div class="col-sm-11">
								<div class="live_photo" v-for="(picName,index) in dataInfo.photos" @click.prevent="getMaxPic($event,picName)" >
									<a v-if="picName.photoStatus==2" class="thumbnail">
										<div :style="{backgroundImage:'url('+ picUrl2 + picName.logourl + ')',backgroundSize:'cover',height:'100px',width:'100px'}"></div>
										<p>{{getPhotoStatus(picName.photoStatus)}}</p>
									</a>
									<a v-else class="thumbnail">
										<div :style="{backgroundImage:'url('+ picUrl + picName.logourl + ')',backgroundSize:'cover',height:'100px',width:'100px'}" ></div>
										<p>{{getPhotoStatus(picName.photoStatus)}}</p>
									</a>
								</div>
							</div>
						</div> -->
				</div>
				<div class="form-horizontal mt20px">
					<div class="form-group text-left">
						<label class="col-sm-6  control-label t_left">救援总结</label>
					</div>
				</div>
				<div class="form-horizontal  ibox-content mt20px">
					<div class="form-group">
						<label class="col-sm-1 control-label">救援总里程</label>
						<div class="col-sm-2 control-label t_left">
							{{dataInfo.totalMileageNote}}
						</div>
						<label class="col-sm-1 control-label">其中至现场里程</label>
						<div class="col-sm-2 control-label t_left">
							{{dataInfo.sceneMileageNote}}
						</div>
						<label class="col-sm-1 control-label">至目的地里程</label>
						<div class="col-sm-2 control-label t_left">
							{{dataInfo.descMileageNote}}
						</div>
						<label class="col-sm-1 control-label">救援结算费用</label>
						<div class="col-sm-2 control-label t_left">
							{{dataInfo.closingCostNote}}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-1 control-label">救援总耗时</label>
						<div class="col-sm-2 control-label t_left">
							{{dataInfo.totalElapsedTimeNote}}
						</div>
						<label class="col-sm-1 control-label">其中至现场耗时</label>
						<div class="col-sm-2 control-label t_left">
							{{dataInfo.sceneElapsedTimeNote}}
						</div>
						<label class="col-sm-1 control-label">至目的地耗时</label>
						<div class="col-sm-2 control-label t_left">
							{{dataInfo.descElapsedTimeNote}}
						</div>
						<label class="col-sm-1 control-label">空驶里程</label>
						<div class="col-sm-2 control-label t_left">
							{{dataInfo.fallEmptyMiles}}<span v-show="dataInfo.fallEmptyMiles !=null || dataInfo.fallEmptyMiles !=''">km</span>
						</div>
					</div>
					<div class="form-group" v-if="!!dataInfo.connectionStartTimeNote&&!!dataInfo.connectionStartTime">
						<label class="col-sm-1 control-label">司机自接单</label>
						<div class="col-sm-11 control-label t_left">
							<span class="gary">{{dataInfo.connectionStartTimeNote}}</span>&nbsp;&nbsp;
							<label>后与客户进行了联系</label>
						</div>

					</div>

					<!--客户评价区域，只允许人保客服（根结点用户）查看。其它用户不显示。当已完成时，才可以评价-->
					<div class="form-group" v-if="isDetailMode && levv!=3 && dataInfo.evaluateStatus!=0">
						<label class="col-sm-1 control-label">客户评价</label>
						<div class="col-sm-11">
							<span class="col-sm-2 control-label clientReview" :class="{active:dataInfo.evaluateStatus==1}" style="cursor:default">好评</span>
							<span class="col-sm-1"></span>
							<span class="col-sm-2 control-label clientReview" :class="{active:dataInfo.evaluateStatus==2}" style="cursor:default">中评</span>
							<span class="col-sm-1"></span>
							<span class="col-sm-2 control-label clientReview" :class="{active:dataInfo.evaluateStatus==3}" style="cursor:default">差评</span>
						</div>
					</div>
					<div class="form-group" v-if="isDetailMode && levv!=3 && dataInfo.evaluateStatus!=0">
						<label class="col-sm-1 control-label">评价详情</label>
						<div class="col-sm-11">
							<textarea type="text" class="form-control" v-model.trim="dataInfo.evaluateRemark" maxlength="254" readonly></textarea>
						</div>
					</div>
				</div>
				<div class="form-horizontal mt20px" v-if="isDetailMode && levv==3 && dataInfo.companyAuditStatus==1 && dataInfo.piccAuditStatus==0">
					<div class="form-group text-left">
						<label class="col-sm-6  control-label t_left">审核信息</label>
					</div>
				</div>
				<div class="form-horizontal  ibox-content mt20px" v-if="isDetailMode && levv==3 && dataInfo.companyAuditStatus==1 && dataInfo.piccAuditStatus==0">
					<div class="form-group">
						<label class="col-sm-1 control-label">救援公司提交时间</label>
						<div class="col-sm-2 control-label t_left">
							{{dataInfo.companyAuditTime}}
						</div>
			  	</div>
				</div>
				<div class="form-horizontal mt20px" v-if="isDetailMode && dataInfo.companyAuditStatus==1 && levv==2 && dataInfo.piccAuditStatus==0">
					<div class="form-group text-left">
						<label class="col-sm-6  control-label t_left">审核信息</label>
					</div>
				</div>
				<div class="form-horizontal  ibox-content mt20px"  v-if="isDetailMode && dataInfo.companyAuditStatus==1 &&  levv==2 && dataInfo.piccAuditStatus==0">
					<div class="form-group">
						<label class="col-sm-1 control-label">救援公司提交时间</label>
						<div class="col-sm-2 control-label t_left">
							{{dataInfo.companyAuditTime}}
						</div>
			  	</div>
				  <div class="form-group">
						<label class="col-sm-1 control-label" style="padding-top:13px">人保审核</label>
						<div class="col-sm-2 control-label t_left">
							<a  class="btn btn-primary white" @click="apprpvalOrder(1)" :disabled="permission.indexOf('rescueServiceOrderList_audit') != -1">通过</a>
							<a  class="btn btn-danger white" @click="apprpvalOrder(2)" :disabled="permission.indexOf('rescueServiceOrderList_audit') != -1">不通过</a>
						</div>
			  	</div>
				</div>
				<div class="form-horizontal mt20px" v-if="isDetailMode && dataInfo.companyAuditStatus==1 && (dataInfo.piccAuditStatus==1 || dataInfo.piccAuditStatus==2)">
					<div class="form-group text-left">
						<label class="col-sm-6  control-label t_left">审核信息</label>
					</div>
				</div>
				<div class="form-horizontal  ibox-content mt20px"  v-if="isDetailMode && dataInfo.companyAuditStatus==1  && (dataInfo.piccAuditStatus==1 || dataInfo.piccAuditStatus==2)">
					<div class="form-group">
						<label class="col-sm-1 control-label">救援公司提交时间</label>
						<div class="col-sm-2 control-label t_left">
							{{dataInfo.companyAuditTime}}
						</div>
			  	</div>
				  <div class="form-group">
						<label class="col-sm-1 control-label">人保审核</label>
						<div class="col-sm-2 control-label t_left">
				       {{dataInfo.piccAuditStatus==1?'通过':'未通过'}}
						</div>
						<label class="col-sm-1 control-label">提交时间</label>
						<div class="col-sm-2 control-label t_left">
				       {{dataInfo.piccAuditTime}}
						</div>
			  	</div>
				</div>
				<!-- 客服评价区域，2.4新增：有评价之后就显示 ，无数据之前不显示。  -->
				<div class="form-horizontal mt20px" v-if="isDetailMode && levv!=3 && dataInfo.customerServiceEvaluateStatus!=0">
					<div class="form-group text-left">
						<label class="col-sm-6  control-label t_left">客服评价</label>
					</div>
				</div>
				<div class="form-horizontal ibox-content mt20px" v-if="isDetailMode && levv!=3 && dataInfo.customerServiceEvaluateStatus!=0">
					<br/>
					<div class="form-group" >
						<label class="col-sm-1 control-label">客服评价</label>
						<div class="col-sm-11">
							<span class="col-sm-2 control-label clientReview" :class="{active:dataInfo.customerServiceEvaluateStatus==1}" style="cursor:default">好评</span>
							<span class="col-sm-1"></span>
							<span class="col-sm-2 control-label clientReview" :class="{active:dataInfo.customerServiceEvaluateStatus==2}" style="cursor:default">中评</span>
							<span class="col-sm-1"></span>
							<span class="col-sm-2 control-label clientReview" :class="{active:dataInfo.customerServiceEvaluateStatus==3}" style="cursor:default">差评</span>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-1 control-label">评价详情</label>
						<div class="col-sm-11">
							<textarea type="text" readonly class="form-control" v-model.trim="dataInfo.customerServiceEvaluateRemark" maxlength="254"></textarea>
						</div>
					</div>
				</div>
				</br>
				<div class="form-horizontal">
					<div class="form-group">
						<div class="col-sm-12 text-center">					 
						  <a  class="btn btn-primary white" @click="approvalConfirm" v-if="isDetailMode && levv==3 && dataInfo.companyAuditStatus==0 && permission.indexOf('rescueServiceOrderList_submit') == -1 && dataInfo.rescueStatus == 3">提交</a>
                            <a class="btn btn-primary white" style="position: absolute;left: 35%;" v-if="dataInfo.customerServiceEvaluateDetail && levv!=3" @click="toComment">客服评价</a>
							<a  class="btn btn-primary white" @click="close" :disabled="!clickable || loadingBtn1 || loadingBtn2" v-if="!(isDetailMode && levv==3) && permission.indexOf('rescueServiceOrderList_save') == -1">保存</a>
							<!--不能出现保存时，显示关闭-->
							<a  class="btn btn-primary white" @click="simClose" v-else>关闭</a>
							<!--初次新建时或已完成、已撤单状态时，撤单不显示；已完成或救援公司查看时，不能编辑-->
							<a  class="btn btn-primary white" @click="cancelOrder" v-if="!(!isDetailMode || dataInfo.rescueStatus==4 || (isDetailMode && levv==3)) && permission.indexOf('rescueServiceOrderList_cancelOrderList') == -1">撤单</a>
							<!--救援单状态为“救援中 -  待人工派单”且 不是新建时,且不是救援公司,且不是从历史救援或司机救援单跳过来时才允许删除-->
							<a class="btn btn-primary white" @click="delOrder" v-if="(dataInfo.rescueStage==12 && isDetailMode && levv!=3) && permission.indexOf('rescueServiceOrderList_delete') == -1">删除</a>
							<!-- v2.4.0新增-点击提交客服评价，司机已接单开始至已完成三日内可以评价 -->
							<!-- 救援中、救援完成订单有空驶按钮 -->
							<a  class="btn btn-primary white" v-show='dataInfo.rescueStatus == 4' @click='emptyBtn'>空驶</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-show="curPage==1" class="grey_box">
			<!--只有已完成 已评价的可以查看轨迹（已撤单不可以）-->
			<div class="form-group text-right"  v-if="dataInfo.rescueStatus == 3">
					<button class="btn btn-primary" @click="goRescueTrack">查看救援轨迹</button>
			</div>
			<div class="form-horizontal ibox-content ">
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>流程编号</th>
								<th>流程开始时间</th>
								<th>流程内容</th>
								<th>流程完成时间</th>
								<th>流程结果</th>
								<th>操作人</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(detail,index) in detailArr" :class="detail.orderClass">
								<td>ST{{detail.processId}}</td>
								<td>{{detail.startTime}}</td>
								<td>{{detail.processContent}}</td>
								<td>{{detail.endTime}}</td>
								<td>{{detail.processResults}}</td>
								<td>{{detail.operatorName}}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!--分页组件开始-->
				<pagination v-if="detailArr.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
			</div>
		</div>
		<!-- 变更救援类型 -->
		<tab-modal ref="changeRescueModal" size="large" :scroll="scrollTop" title="变更救援类型" @cancel="closeRescueModal">
			<div class='form-horizontal'>
				<div class="form-group">
					<label class="col-sm-3 t_right">当前救援类型：</label>
					<div class="col-sm-9">	
						<span>{{dataInfo.rescueTypeName}}</span>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-3 t_right red">*变更救援类型：</label>
					<div class="col-sm-2 t_left" v-for="type in rescueTypeList" :key='type.udccode'> 
						<input type="radio" :value="type.udccode" v-model="chrescueType"/>
						<span>{{type.udcname}}</span>
					</div>
				</div>
				<div class='dioArrtxt'>
					<span class="help-block red" v-if="chrescueType == ''">{{chreserror}}</span>
				</div>
				<div class="form-group" v-show="chrescueType == 1 || chrescueType == 4">
					<label class="control-label col-sm-3 t_right red">*目的地变更：</label>
					<div class='col-sm-7'>
						<input type="text" class="form-control" id="newdestination" size="20" placeholder="请输入地址" v-model.trim="changeDestination" @focus.once="destinationAdds"/>
						<div id="newdestinationPanel" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
					</div>
					<div class='col-sm-2'>
						<button @click="openMapTab(changedestPoints,changeDestination,1)" :disabled="!changedestPoints" v-loading='loadingBtdest' class="btn btn-primary white">地图</button>
					</div>
					<div class='dioArrtxt'>
						<span class="help-block red" v-if="changeDestination == ''">{{desterror}}</span>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-primary" @click='closeRescueModal'>取消</button>
				<button class="btn btn-primary" @click='confimRescue'>确定</button>
			</div>
		</tab-modal>
		<!-- 内部调度-->
		<tab-modal ref="schedulingModal" size="large" :scroll="scrollTop" title="变更救援类型" @cancel="closeschedulingModal">
			<div class='form-horizontal'>
				<div class="form-group">
					<label class="col-sm-2 t_right">当前司机：</label>
					<div class="col-sm-10">	
						<span>{{dataInfo.driverName}}</span>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 t_right">救援类型：</label>
					<div class="col-sm-10">	
						<span>{{dataInfo.rescueTypeName}}</span>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 t_right red">*变更司机：</label>
					<div class="col-sm-9 t_left">
						<select class='form-control' v-model="availableModel"  @change="changeavailable($event)">
							<!-- :ref="'datid'+item.driverId"  -->
							<option v-for="item in availableList" :value="item.driverId+'、'+item.vehicleId" ref="dataMsg" :data-msg='item.vehicleId' :label='item.driverName' :key='item.vehicleId'></option>
						</select>
					</div>
				</div>
				<div class='dioArrtxt'>
					<span class="help-block red" v-if="availableModel == ''">{{availserror}}</span>
				</div>
				
			</div>
			<div slot="footer">
				<button class="btn btn-primary" @click='closeschedulingModal'>取消</button>
				<button class="btn btn-primary" @click='confimscheduling'>确定</button>
			</div>
		</tab-modal>
		<!--取消重派开始-->
		<tab-modal ref="reDispatchModal" size="normal" :scroll="scrollTop" title="取消重派" @cancel="closeReDispatch">
			<div>
				<label class="control-label col-sm-12">您将要取消当前的派车信息，重新安排其他救援车辆。目前已派车辆将被中止。您确定要继续吗？</label>
				<div class="form-group">
					<label class="control-label col-sm-2 red">*取消原因：</label>
					<div class="col-sm-10  mb20px">
						<select class="form-control" v-model="reSendStatus">
							<option value="53">司机未能完成</option>
							<option value="62">客服派单有误</option>
						</select>
					</div>
				</div>
				<div class="form-group">
					<label class="control-label col-sm-2">原因说明：</label>
					<textarea class="col-sm-10" v-model="reSendReason"></textarea>
				</div>
			</div>
			<div slot="footer">
				<button v-if="levv!=3" class="btn btn-primary" @click="autoReDispatch">自动重派</button>
				<button class="btn btn-primary" @click="handReDispatch">人工重派</button>
			</div>
		</tab-modal>
		<!--撤单弹框开始-->
		<tab-modal ref="cancelOrderModal" size="normal" :scroll="scrollTop" title="撤单" @cancel="closeCancelM">
			<div v-if="firstStep">
				<label class="control-label col-sm-12">本次救援将被撤销。撤销某个救援时，您需要记录本次救援被撤销的原因：</label>
				<div class="form-group">
					<label class="control-label col-sm-2 red">*原因类别：</label>
					<div class="col-sm-10  mb20px">
						<select class="form-control" v-model.trim="killOrderStatus" >
							<option value="41">客户主动取消</option>
							<option value="42">未能找到现场</option>
							<option value="43">救援录入重复</option>
						</select>
					</div>
				</div>
				<div class="form-group">
					<label class="control-label col-sm-2 red">*原因详细：</label>
					<div class="col-sm-10" >
						<textarea v-model.trim="killOrderReason" class="form-control"></textarea>
					</div>
				</div>
			</div>
			<div v-else>
				<label class="control-label">您即将撤销单号为RS{{dataInfo.id}}的救援单。救援单被撤销后，相关的救援工作也将中止，且此操作不能被恢复。</label>
				<label class="control-label">您确定要继续吗？</label>
			</div>
			<div slot="footer">
				<span class="help-block red" v-if="showMsg">请填写完整信息</span>
				<button class="btn btn-primary" @click="closeCancelM">取消</button>
				<button class="btn btn-primary" @click="confirmCancel">确定</button>
			</div>
		</tab-modal>
		<tab-modal ref="plateNumModal" size="small" title="提示" :scroll="scrollTop" @cancel="closePlateModal">
			<p>{{remindContent}}</p>
			<div slot="footer">
				<button class="btn btn-primary" @click="closePlateModal">取消</button>
				<button class="btn btn-primary" @click="ignoreSamePlateNum">确定</button>
			</div>
		</tab-modal>
		<tab-modal ref="approvalSumitModal" size="small" title="提示" :scroll="scrollTop" @cancel="closeApprovalSumitModal" :offsetHeight="offsetHeight">
			<p>是否确认提交？</p>
			<div slot="footer">
				<button class="btn btn-primary" @click="closeApprovalSumitModal">取消</button>
				<button class="btn btn-primary" @click="submitApproval">确定</button>
			</div>
		</tab-modal>
		<!-- 空驶弹窗 -->
		<tab-modal ref="emptyModal" size="normal" :scroll="scrollTop" title="空驶" @cancel="cancelEmpty">
			<div>
				<div class="form-group">
					<label class="control-label col-sm-2 red">*空驶里程：</label>
					<div class="col-sm-10  mb20px">
						<input type="text" class="form-control" @input='rileRest' v-model="emptyMile">
					</div>
					<div class='text_ar'>
						<span class="help-block red" v-if="showMile">{{showMile}}</span>
					</div>
				</div>
				<div class="form-group">
					<label class="control-label col-sm-2 red">*空驶原因：</label>
					<div class="col-sm-10" >
						<textarea v-model="emptyReason" maxLength='100' class="form-control"></textarea>
					</div>
					<div class='text_ar'>
						<span class="help-block red" v-if="showReason">{{showReason}}</span>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-primary" @click='cancelEmpty'>取消</button>
				<button class="btn btn-primary" @click='confimEmpty'>确定</button>
			</div>
		</tab-modal>
		<!--【人保四期】新增人保坐席派单给救援公司-->
		<tab-modal ref="dispatchModal" size="normal" title="向救援公司派单" :scroll="scrollTop" @cancel="closeDispatchM">
			<div>
				<label class="control-label">请选择您将要派单的救援公司：</label>
				<select class="form-control" v-model="selRescueCorpId" v-if="dataInfo.rescueType !== 5">
					<option v-for="corp in rescueCompanys" :value="corp.id">{{corp.groupName}}</option>
					<!--<option value="">人保救援车队</option>
					<option value="">人保救援车队1</option>
					<option value="">人保救援车队2</option>
					<option value="">人保救援车队3</option>-->
				</select>
				<select class="form-control" v-model="selRescueCorpId" v-if="dataInfo.rescueType === 5">
					<option :value="otherId">{{otherGroupName}}</option>
				</select>
			</div>
			<div slot="footer">
				<button class="btn btn-primary" @click="closeDispatchM">取消</button>
				<button class="btn btn-primary" :disabled="btnLoading" @click="confirmDispatchM">确定</button>
			</div>
		</tab-modal>
		<!-- 【v2.4.0】调整：客服评价以弹框形式 -->
		<tab-modal ref="commentModal" size="normal" title="客服评价" :scroll="scrollTop" @cancel="stopComment">
			<div>
				<div class="row form-horizontal">
					<label class="col-sm-2 control-label">客服评价</label>
					<div class="col-sm-10">
						<span class="col-sm-2 control-label clientReview" :class="{active:customerServiceEvaluateStatus==1}" @click="setRemark(1)">好评</span>
						<span class="col-sm-1"></span>
						<span class="col-sm-2 control-label clientReview" :class="{active:customerServiceEvaluateStatus==2}" @click="setRemark(2)">中评</span>
						<span class="col-sm-1"></span>
						<span class="col-sm-2 control-label clientReview" :class="{active:customerServiceEvaluateStatus==3}" @click="setRemark(3)">差评</span>
					</div>
				</div>
				<br/>
				<div class="row form-horizontal">
					<label class="col-sm-2 control-label">评价详情</label>
					<div class="col-sm-10">
						<textarea type="text" class="form-control" v-model.trim="customerServiceEvaluateREMARK" maxlength="254"></textarea>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-primary" @click="stopComment">取消</button>
				<button class="btn btn-primary" @click="confirmComment">确定</button>
			</div>
		</tab-modal>
		<!--提示弹框开始-->
		<tab-modal ref="modalMsg" size="small" title="提示" :scroll="scrollTop" @cancel="closeMsgTip">
			{{tipContent}}
			<div slot="footer">
				<button class="btn btn-primary" @click="closeMsgTip" v-if="showWithdraw">取消</button>
				<button class="btn btn-primary" @click="confirmMsgTip">确定</button>
			</div>
		</tab-modal>
		<div class="sub_page_box">
			<sub-page :show="showConfirm" 
				bigTitleMsg="提示" 
				v-on:cancel="closeConfirm" 
				:width='20'
				:scroll="scrollTop">
				<div slot="bodycontent">
					<div style="padding:20px;font-size:14px">
					<p>是否确认提交？</p>
					</div>
					<div style="padding:20px 20px;text-align:center">
						<button class="btn btn-primary" @click="closeConfirm">取消</button>
						<button class="btn btn-primary" @click="submitApproval">确定</button>
					</div>
				</div>
			</sub-page>
		</div>
		<!--定位子tab-->
		<div class="sub_page_box">
			<sub-page
				:show="openLocate"
				bigTitleMsg="救援地址定位"
				v-on:cancel="closeLocate"
				:scroll = 'scrollTop'
				>
				<div slot="bodycontent">
					<page-rescue-service-order-locate
						v-if="openLocate"
						:points="locPoints"
						:address="locAddress"
						:type="locType"
						v-on:saveNewPos="saveNewPos"
					>
					</page-rescue-service-order-locate>
				</div>
			</sub-page>
		</div>
	</div>
</template>
<script>
	import { zh } from 'flatpickr/dist/l10n/zh'
import TabModal from 'components/common/TabModal'
import SubPage from 'components/common/SubPage'
import { SAVE_ENSURE, OPERATE_EXCEPTION } from 'static/message'
import { required, maxLength } from 'vuelidate/lib/validators'
import Datepicker from 'components/common/datepicker/Datepicker'
import PageRescueServiceOrderLocate from 'components/pages/rescueservice/PageRescueServiceOrderLocate'
import {deepCopy} from 'util/util'
import classlist from 'util/classlist'
import Pagination from 'components/common/Pagination'
import Mock from 'mockjs'
	import RescueOrderPics from 'components/common/RescueOrderPics'
	export default{
	  name: 'PageRescueServiceOrderEdit',
	  components: {
	    Datepicker,
	    TabModal,
	    SubPage,
	    Pagination,
	    PageRescueServiceOrderLocate,
	    RescueOrderPics
	  },
	  data () {
	    return {
	      permission: this.$store.state.permission.permission['rescueServiceOrderLi'] ? this.$store.state.permission.permission['rescueServiceOrderLi'] : [],
	      loadingorder: false,
	      loadingBtn1: false,
	      loadingBtn2: false,
	      tipContent: '',
	      remindContent: '',
	      showWithdraw: false, // 提示弹框是否显示取消按钮（确认是否重新派单时）
	      localeOption: {
			        locale: zh,
			        enableTime: true,
			        enableSeconds: true,
			        time_24hr: true,
			        minDate: new Date()
			    },
			    timeDisable: true, // 派单时间不可编辑
			    token: window.localStorage.getItem('accesstoken'),
			    evaluateStatusList: [],
			    rescueStageList: [],
			    dateTypeList: [],
			    rescueTypeList: [],
			    trackUdccode: 1,
      isDetailMode: false,
      wechatCase: [],
	      formInfo: {
        identifyNo: '',              // 客户身份证
        employeeNo: '',                  // 客服工号
        wechatOrderCause: '',            // 拒绝微信下单理由
	        cancelReason: '',			   // 原因详情           1
	        cancelStatus: 41,			   // 撤单原因          2
	        dateType: 0,  				   // 时间类型-默认0实时	  3
	        id: '',	                       // 救援单号     4
	        requestTime: this.curDateStr,  // 请求时间-默认当前时间    5
	        rescueStageName: '',			   // 阶段描述     6
	        rescueStageTime: '',			   // 救援阶段时间   7
	        rescueStage: 11,                // 救援阶段  8
	        rescueStatusName: '待救援',
	        rescueStatusDetail: '',		   // 救援状态描述  9
	        rescueStatus: '1',			   // 救援状态-默认待救援-自动派单  10
	        rescueType: '',				   // 救援类型         11
	        isUnderground: 0,			   // 是否是地库拖车类型   0 否 1是
	        customerName: '',			   // 救援公司     12
	        dispatchTime: '',			   // 派单时间    13
	        driverName: '',				   // 司机      14
	        driverPhone: '',                // 司机电话   15
	        photos: '',				   // 现场照片   16
	        plateNumber: '',               // 车牌号   17
	        closingCost: '',					// 结算费用   18
	        connectionStartTime: '',        // 司机联系时间（接单后多长时间）  19
	        descElapsedTime: '',            // 到目的地耗时   20
	        descMileage: '',				   // 至目的地里程 21
	        evaluateRemark: '',			   // 评价详情	 22
	        evaluateStatus: '',			   // 客户评价        23
	        sceneElapsedTime: '',		   // 至现场耗时  24
	        sceneMileage: '',               // 到现场里程 25
	        totalElapsedTime: '',		   // 救援总耗时  26
	        totalMileage: '',			   // 救援总里程  27
	        destAddress: '',				   // 目的地址  28
	        destAddressDetail: '',          // 目的详细    29
	        destPoints: '',				   // 目的点    30
	        rescuedAddress: '',             // 救援地址  31
	        rescuedAddressDetail: '',	   // 详细地址   32
	        rescuedColor: '',               // 颜色
	        rescuedMemo: '',			   // 救援备注
	        rescuedModel: '',			   // 车型
	        rescuedName: '',                // 车主姓名
	        rescuedPhone: '',			   // 手机号
	        rescuedPlateNumber: '',		   // 救援车牌号
        rescuedPoints: '',			   // 救援点
        certificatesTypeString: '',      // 服务单来源
        rescueTimes: '' // 救援次数
	      },
		  chrescueType:'',
		  changeDestination:'',//变更拖车地址
		  changedestPoints:'',//变更地址经纬度
		  chreserror:'',//错误提示
		  desterror:'',//错误提示
		  loadingBtdest:false,//地图loading
		  availableModel:'',//变更司机
		  availserror:"",
		  availableList:[],//变更司机列表
		  emptyMile:'',//空驶里程
		  emptyReason:'', //空驶原因
		  showMile:'',
		  showReason:'',
	      dataInfo: {},
	      dateType: 0,
	      requestTime: '',
	      scrollTop: '',
	      openLocate: false,
	      disposeAutoComplete: false,
	      curPage: 0,
	      firstStep: true,		  // 第一步
	      killOrderStatus: '41',  // 撤单原因
	      killOrderReason: '',  // 撤单原因详细
	      reSendStatus: '53',    // 取消派单原因
	      reSendReason: '',     // 取消原因详情
	      showMsg: false,		// 是否显示提示
				// 救援地址相关-----
	      mapCenter: {lng: 120.39, lat: 36.073},
	      mapZoom: 15,
	      enableScroll: true,
	      offsetHeight: 0,
				// 派单详情--------
	      detailArr: [],
	      pageInfo: {},
	      rid: '',
	      picUrl: process.env.PIC_PATH,
	      picUrl2: process.env.PIC_PATH2,
				// 【人保四期】向救援公司派单
	      rescueCompanys: [],
	      selRescueCorpId: '',
	      detailTimer: null,
	      fresh: null,
	      gpsSource: 0,
				// v2.4.0客服评价
	      customerServiceEvaluateStatus: '',
	      customerServiceEvaluateREMARK: '',
				showConfirm: false,
				btnLoading: false,
				otherId: '',
				otherGroupName: ''
	    }
	  },
	  validations: {
	    dataInfo: {
	      dateType: {
	        required
      },
      employeeNo: {
	        required
      },
      wechatOrderCause: {
	        required
      },
	      requestTime: {
	        required
	      },
	      rescueStage: {
	        required
	      },
	      rescueType: {
	        required
	      },
	      cancelStatus: {
	        required
	      },
	      cancelReason: {
	        required
	      },
	      rescuedPhone: {
	        required
	      },
	      rescuedAddress: {
	        required
      },
      policyNo: {
        required
      },
	      rescuedMemo: {
	        maxLength: maxLength(254)
	      },
	      remark: {
	        maxLength: maxLength(254)
	      },
	      rescuedPlateNumber: {
	        required
	      },
	      withdrawReason: {
	        required
	      },
	      withdrawStatus: {
	        required
      },
      policyNo: {
        required
      }
	    }
	  },
	  computed: {
	    realTimeCode () {
	      let code = 0
	      this.dateTypeList.map(item => {
	        if (item.udcname == '实时') {
	          code = item.udccode
	        }
	      })
	      return code
	    },
	    statusDetail () {
				// 救援公司登录时-待救援状态下marginTop=0
	      let term1 = this.levv == 3 && (this.dataInfo.rescueStage == 13 || this.dataInfo.rescueStage == 12 || this.dataInfo.rescueStage == 11 || this.dataInfo.rescueStage == 51 || this.dataInfo.rescueStage == 52 || this.dataInfo.rescueStage == 53)
	      if (term1) {
	        return
	      }
	      if (!(this.dataInfo.rescueStage == 32 || this.dataInfo.rescueStage == 31 || this.dataInfo.rescueStage == 41 || this.dataInfo.rescueStage == 42 || this.dataInfo.rescueStage == 43)) {
	        return {
	          marginTop: '-8px'
	        }
	      }
	    },
	    levv () {
	      return this.$store.state.user.levv
	    },
	    clickable () {
	      let cancel = true
	      if (this.dataInfo.requestStatus == 4) {
	        cancel = this.$v.dataInfo.cancelStatus.required && this.$v.dataInfo.cancelReason.required
	      } else {
	        cancel = true
	      }
	      let rescuedMemo = true
	      if (this.dataInfo.rescuedMemo != '') {
	        rescuedMemo = this.$v.dataInfo.rescuedMemo.maxLength
	      } else {
	        rescuedMemo = true
	      }
	      return this.$v.dataInfo.dateType.required && this.$v.dataInfo.requestTime.required && this.$v.dataInfo.rescueStage.required &&
			this.$v.dataInfo.rescueType.required && cancel &&
        this.$v.dataInfo.rescuedPhone.required && this.phoneSet && this.$v.dataInfo.rescuedAddress.required && this.$v.dataInfo.rescuedPlateNumber.required &&
        this.$v.dataInfo.policyNo.required && this.checkPolicyNo &&
			rescuedMemo
	    },
	    phoneSet () {
	      if (!this.dataInfo.rescuedPhone) {
	        return true
	      } else {
	        return /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/.test(this.dataInfo.rescuedPhone)
	      }
    },
    checkCertificatesNoC () {
      if (this.dataInfo.identifyNo) {
        return /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(this.dataInfo.identifyNo)
      }
      return true
    },
    checkPolicyNo () {
      if (!this.dataInfo.policyNo) {
        return true
      } else if (this.dataInfo.policyNo && this.dataInfo.policyNo.length == 22) {
        return true
      } else {
        return false
      }
    },
	    curDateStr () {
	      let timeCur = this.getCurDate()
	      return timeCur
	    }
	  },
	  //自定义指令 限制输入0＞ 空驶里程≤100，精确值小数点后1位
	  directives: {
        inputrule:{
            bind: function(el) {
              const elvalue = el.getElementsByTagName('input')
              elvalue.handler = function() {
                  if(elvalue.value > 100){
                    if(elvalue.value.length>3){
                      elvalue.value = elvalue.value.slice(0,3)
                    }
                  }
                }
                elvalue.addEventListener('input', elvalue.handler)
              return
            },
            unbind: function(el) {
              const elvalue = el.getElementsByTagName('input')
              elvalue.removeEventListener('input', elvalue.handler)
            }
        }
  },
	  watch: {
	    'dataInfo.dateType' (val) {
	      let curDate = this.getCurDate()
	      if (!this.isDetailMode) { // 新建模式
	        if (val == this.realTimeCode) { // 预约->实时
	          this.dataInfo.requestTime = curDate
	        } else { // 实时->预约
	          this.dataInfo.requestTime = ''
	        }
	      } else {
	        if (val == this.realTimeCode) { // 预约->实时
	          if (this.dateType == 1) { // 预约单切换成实时
	            this.dataInfo.requestTime = curDate
	          } else { // 非预约单切换成预约再切回来
	            this.dataInfo.requestTime = this.requestTime
	          }
	        } else { // 实时->预约
	          if (this.dateType == 1) { // 预约单切换成实时再切换回来
	            this.dataInfo.requestTime = this.requestTime
	          } else { // 非预约单切换成预约单
	            this.dataInfo.requestTime = ''
	          }
        }
	      }
	    },
	    'dataInfo.rescuedAddress' (newVal, oldVal) {
			//	console.log('oldd')
			//	console.log(this.dataInfo)
	      if (oldVal && this.gpsSource == 0) {
	        this.dataInfo.rescuedPoints = ''
			//		console.log('delete')
	      }
	    },
	    'dataInfo.destAddress' (newVal, oldVal) {
			//	console.log(this.dataInfo)
			//	console.log('old' + oldVal)
			//	console.log('new' + newVal)
	      if (oldVal && this.gpsSource == 0) {
				//	this.loadingBtn2 = true
	        this.dataInfo.destPoints = ''
	        if (!newVal) {
					//	console.log('newVal为空')
	          this.dataInfo.destPoints = ''
	          this.dataInfo.destAddress = ''
	        }
	      }
	    },
		//弹窗变更目的地地图
		changeDestination:function(newVal,oldVal){
			if (oldVal && this.gpsSource == 0) {
				this.changedestPoints = ''
			}
		},
		emptyMile:function(val){
			if(val){
				if(val == 0){
					this.showMile = '请输入大于0的里程数'
				}else{
					this.showMile = ''
				}	
			}else{
				this.showMile = '请输入空驶里程'
			}
		},
		emptyReason:function(val){
			if(val){
				this.showReason = ''
			}
			else{
				this.showReason = '请输入空驶原因'
			}
		},
	  },
	  created () {
		  	this.rid = this.$route.query.id
		  	this.isDetailMode = this.$route.query.detailMode != 0
		  	if (this.isDetailMode) {
		  		this.initOrderForm(this.rid)  // 获取表单数据
		  		this.getDispatchDetail(this.rid, 1)      // 获取派单详情
		  		// 轮巡拉取派单详情
		  		this.refreshDispatchDetail()
		  	} else {
		  		this.resetFormInfo()          // 重置表单数据
		  		this.getUdc()  // 获取字典表数据
		  	}
	  },
	  beforeDestroy () {
	    clearTimeout(this.detailTimer)
	    this.detailTimer = null
	  },
	  methods: {
		  //监听是否需要刷新
		refinfo(val){
			this.initOrderForm(this.dataInfo.id)
		},
	    apprpvalOrder (status) {
	      this.loadingorder = true
	      this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/piccAudit/', {id: this.rid, auditStatus: status}, {emulateJSON: true}).then(res => {
					// 跳转到轨迹页面
	        this.loadingorder = false
        if (res.data.success) {
	          this.openMsgTip('审核成功！')
	          this.initOrderForm(this.rid)
	        } else {
	          this.openMsgTip(res.body.message)
	        }
	      }, res => {
	        this.loadingorder = false
	        this.openMsgTip(res.body.message)
	        if (res.body.message == '') {
	          this.openMsgTip('请求出问题啦，请稍后重试')
	        }
	      }).catch(res => {
	        this.loadingorder = false
	        this.openMsgTip(OPERATE_EXCEPTION)
	      })
	    },
			// 救援公司提交审核
	    submitApproval () {
	      this.loadingorder = true
	      this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/companySubmit/' + this.rid, {emulateJSON: true}).then(res => {
	        this.loadingorder = false
					// 跳转到轨迹页面
        if (res.data.success) {
	          this.openMsgTip('提交成功！')
	          this.initOrderForm(this.rid)
	          this.showConfirm = false
	        } else {
	          this.openMsgTip(res.body.message)
	        }
	      }, res => {
	        this.loadingorder = false
	        this.openMsgTip(res.body.message)
	        if (res.body.message == '') {
	          this.openMsgTip('请求出问题啦，请稍后重试')
	        }
	      }).catch(res => {
	        this.loadingorder = false
	        this.openMsgTip(OPERATE_EXCEPTION)
	      })
	    },
	    setUpperCase () {
	      this.dataInfo.rescuedPlateNumber = this.dataInfo.rescuedPlateNumber.toUpperCase()
	    },
	    changePage (num) { // 基本信息和派单详情切换
	      this.curPage = num
	    },
	    initOrderForm (id) { // 详情时，获取form数据
	      this.loadingorder = true
	      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/' + id).then(res => {
				//	this.loadingorder = false
	        const resInfo = res.body.data
			//	if(!resInfo) return
	        this.dataInfo = resInfo
	        this.dateType = resInfo.dateType  // 用来判断是预约单还是非预约单
	        this.requestTime = resInfo.requestTime  // 用来存储后台返回的实际请求时间或预约时间
	        if (this.dataInfo.isUnderground == 1 && this.dataInfo.rescueType == 1) {
	          this.dataInfo.rescueType = 4
	        }
	        this.getUdc()  // 获取字典表数据
	      }, res => {
	        this.loadingorder = false
	        this.showWithdraw = false
	        this.openMsgTip(res.body.message)
	        if (res.body.message == '') {
	          this.openMsgTip('请求出问题啦，请稍后重试')
	        }
	      })/* .catch( res => {
					this.loadingorder = false
					this.showWithdraw = false
					this.openMsgTip(OPERATE_EXCEPTION)
				}) */
	    },
	    goRescueTrack () { // 查看救援轨迹
				// 调追加救援轨迹接口
	      const param = {
	        orderId: this.dataInfo.id,
	        vehicleId: this.dataInfo.vehicleId
	      }
	      this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/trace/traces/rescue', param, {emulateJSON: true}).then(res => {
					// 跳转到轨迹页面
	        const obj = {
	          name: '救援车辆轨迹',
	          id: 'PageVehicleTrace',
	          route: '/indexhome/vehicleTrace',
	          No: 'vehicleTrace'
	        }
	        this.$router.push(obj.route)
	        this.$store.dispatch('addTab', obj)
	        this.$store.dispatch('getTraceList', 1)
	      }, res => {
	        this.showWithdraw = false
	        this.openMsgTip(res.body.message)
	        if (res.body.message == '') {
	          this.openMsgTip('请求出问题啦，请稍后重试')
	        }
	      }).catch(res => {
	        this.showWithdraw = false
	        this.openMsgTip(OPERATE_EXCEPTION)
	      })
	    },
	    getDispatchDetail (id, num) { // 获取派单详情
	      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/' + id + '/history', {params: {page_index: num}}).then(res => {
	        if (!this._isDestroyed) {
	    				clearTimeout(this.detailTimer)
	          this.detailTimer = setTimeout(this.fresh, 1000)
	    			}
    				let obj = res.body.data
    				this.detailArr = obj.list
    				const {pageNum, pages, total, isFirstPage, isLastPage} = obj
    				this.pageInfo = {
	      pageNum: pageNum,
	      pages: pages,
	      total: total,
	      isFirstPage: isFirstPage,
	      isLastPage: isLastPage
	    }
    				for (let i = 0, len = this.detailArr.length; i < len; i++) {
    						if (this.detailArr[i].rescueStage == 32) {
    							if (this.detailArr[i].evaluateStatus == 1) { // 好评--绿色
	    							this.detailArr[i].orderClass = 'green_bg'
	    						} else if (this.detailArr[i].evaluateStatus == 2) { // 中评--黄色
	    							this.detailArr[i].orderClass = 'yellow_bg'
	    						} else { // 差评
	    							this.detailArr[i].orderClass = 'red_bg'
	    						}
    						} else {
    							if (this.detailArr[i].rescueStage == 21) { // 接单--黄色
	    							this.detailArr[i].orderClass = 'yellow_bg'
	    						} else if (this.detailArr[i].rescueStage == 31) { // 完成--绿色
	    							this.detailArr[i].orderClass = 'green_bg'
	    						} else {
	    							continue
	    						}
    						}
    				}
	      }, res => {
	        if (!this._isDestroyed) {
	    				clearTimeout(this.detailTimer)
	          this.detailTimer = setTimeout(this.fresh, 1000)
	    			}
	        this.showWithdraw = false
	        this.openMsgTip(res.body.message)
	        if (res.body.message == '') {
	          this.openMsgTip('请求出问题啦，请稍后重试')
	        }
	      })
	    },
	    refreshDispatchDetail () { // 轮巡拉取派单详情
	      let count = 29
	      const that = this
	      clearTimeout(this.detailTimer)
	      this.fresh = function () {
	        if (count > 0 && count <= 29) {
	          count--
	        } else {
	          count = 29
	        }
	        if (count === 0) {
	          let pageNo = that.pageInfo.pageNum ? that.pageInfo.pageNum : 1
	          console.log('refresh' + '---' + pageNo + '---' + new Date())
	          that.getDispatchDetail(that.rid, pageNo)
	        } else {
	          that.detailTimer = setTimeout(that.fresh, 1000)
	        }
      }
	      this.detailTimer = setTimeout(this.fresh, 1000)
	    },
			// 从分页组件获取页码参数
	    getPageNo (param) {
			//	clearTimeout(this.detailTimer);
	      this.getDispatchDetail(this.rid, param)
	    },
	    resetFormInfo () { // 新建时，重置form信息
			//	this.$v.dataInfo.address.$reset()
	      this.formInfo.requestTime = this.curDateStr
	      this.dataInfo = deepCopy(this.formInfo)
			//	Object.assign(this.dataInfo,this.formInfo);
	    },
			// 保存---------------------
	    simClose () { // 仅仅关闭
				// 关闭当前tab
	      let navList = this.$store.state.home.tabList
	      let curIndex = navList.findIndex(n => n.route == this.$route.path)
	      this.$store.dispatch('closeDetailTab', {index: curIndex, route: '/indexhome/rescueServiceOrderList'})
      this.$router.push('/indexhome/rescueServiceOrderList')
	    },
	    close () {
	      if (!!this.dataInfo.rescuedAddress && !this.dataInfo.rescuedPoints) {
	        this.loadingorder = false
	        this.showWithdraw = false
	        this.openMsgTip('获取救援坐标失败，请重新输入地址')
	        return
	      }
	      if (!!this.dataInfo.destAddress && !this.dataInfo.destPoints) {
	        this.loadingorder = false
	        this.showWithdraw = false
	        this.openMsgTip('获取目的地坐标失败，请重新输入地址')
	        return
	      }
	      if (!this.clickable) {
	        return
	      }
	      this.handleSave()
	    },
    isPlateNumberOk () { // 判断有无重复的车牌号或该车牌号存在在黑名单中
	      const param = {
	        rescuedPlateNumber: this.dataInfo.rescuedPlateNumber,
	        rescueId: this.dataInfo.id
	      }
	      this.loadingorder = true
	      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/check/duplicate/plateNumber', {params: param}).then(res => {
	        const noRepeat = res.body.data.status// true: 无重复  false:重复
	        this.loadingorder = false
	        if (!noRepeat) {
          this.showWithdraw = false
					// this.$refs.plateNumModal.open()
					// this.remindContent = res.body.data.describe;
					// classlist.toggleScroll('close','#rescueserviceorder-edit' + this.dataInfo.id,this);
				//	this.samePlateNum = true;
	          this.openMsgTip(res.body.data.describe)
	        }
	      }, res => {
	        this.loadingorder = false
	        this.showWithdraw = false
	        this.openMsgTip(res.body.message)
      })
			},
		checkPoliceNoPost () {
			// 已用救援次数
			if (this.isDetailMode || !this.dataInfo.policyNo) {
				return
			}
			let timesParam = {
				policyNoData: this.dataInfo.policyNo
			}

			this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/client/get/rescue/count?plateNumbers=', {params: timesParam}).then(res => {
					this.dataInfo.rescueTimes = res.body[this.dataInfo.policyNo]
					}, res => {
						this.loadingorder = false
						this.showWithdraw = false
						this.openMsgTip(res.body.message)
			})
		},
		//空驶里程限制 限制输入0＞空驶里程≤100，精确值小数点后1位
		rileRest(){
			this.emptyMile = this.emptyMile.replace(/[^\d.]/g,"").replace(/^\./g,"").replace(/\.{2,}/g,".")
			.replace(".","$#$").replace(/\./g,"").replace("$#$",".").replace(/^(\-)*(\d+)\.(\d).*$/,"$1$2.$3")
			if(this.emptyMile>100){
				this.emptyMile = 100
			}
				
		},
		//空驶
		emptyBtn(){
			this.$refs.emptyModal.open()
			this.showMile = ''
			this.showReason = ''
			classlist.toggleScroll('close', '#rescueserviceorder-edit' + this.dataInfo.id, this)	
		},
			//取消空驶里程弹窗
		cancelEmpty(){
			this.$refs.emptyModal.close()
			classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
			this.emptyMile = ''
			this.emptyReason = ''
		},
		//确定空驶
		confimEmpty(){
			let param = {
				fallEmpty:true,
				fallEmptyReason:this.emptyReason,
				fallEmptyMiles:this.emptyMile
			}
			if(this.emptyMile == ''){
				this.showMile = '请输入空驶里程'
				return false
			}
			if(this.emptyMile == 0){
				this.showMile = '请输入大于0的里程数'
				return false
			}
			if(this.emptyReason == ''){
				this.showReason = '请输入空驶原因'
				return false
			}
			this.loadingorder = true
			this.$http.put(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/'+this.dataInfo.id+'/fallEmpty', param, {emulateJSON: true}).then(res => {
				if (res.data.success) {
					this.loadingorder = false
					// 关闭当前tab并自动刷新一览表格
					this.closeAndRefresh()
					// 更新监控平台定位
					this.adjustRescueAdd()
				}else{
					this.loadingorder = false
					this.openMsgTip(res.data.message)
				}
				
			}, res => {
				this.loadingorder = false
				if (res.body.message == '') {
				this.openMsgTip('请求出问题啦，请稍后重试')
				} else {
				this.openMsgTip(res.data.message)
				}
			}).catch(res => {
				this.loadingorder = false
				this.openMsgTip(OPERATE_EXCEPTION)
			})
		},
	    closePlateModal () {
	      classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	      this.$refs.plateNumModal.close()
	      this.remindContent = ''
	    },
	    approvalConfirm () {
	      this.showConfirm = true
			 classlist.toggleScroll('close', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    },
		  closeApprovalSumitModal () {
	    classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    this.$refs.approvalSumitModal.close()
	  },
	    ignoreSamePlateNum () { // 忽略重复车牌号现象，仍然保存
	      this.closePlateModal()
	      this.handleSave()
	    },
	    handleSave () {
	      if (this.dataInfo.rescueType == 4) {
	        this.dataInfo.rescueType = 1
	        this.dataInfo.isUnderground = 1
	      } else {
	        this.dataInfo.isUnderground = 0
	      }
	      if (this.isDetailMode) { // 编辑保存
	        let param1 = {
	          cancelReason: this.dataInfo.cancelReason,
	          cancelStatus: this.dataInfo.cancelStatus,
	          dateType: this.dataInfo.dateType,
	          rescueStage: this.dataInfo.dateType == 1 && this.dataInfo.rescueStatus == 1 ? 12 : this.dataInfo.rescueStage,
	          id: this.dataInfo.id,
	          requestTime: this.dataInfo.requestTime,
	          rescueType: this.dataInfo.rescueType,
	          evaluateRemark: this.dataInfo.evaluateRemark,
	          evaluateStatus: this.dataInfo.evaluateStatus,
	          destAddress: this.dataInfo.destAddress,
	          destAddressDetail: this.dataInfo.destAddressDetail,
	          destPoints: this.dataInfo.destPoints,
	          rescuedAddress: this.dataInfo.rescuedAddress,
	          rescuedAddressDetail: this.dataInfo.rescuedAddressDetail,
	          rescuedColor: this.dataInfo.rescuedColor.replace(/\s+/g, ''),
	          rescuedMemo: this.dataInfo.rescuedMemo,
	          rescuedModel: this.dataInfo.rescuedModel,
	          rescuedName: this.dataInfo.rescuedName,
	          rescuedPhone: this.dataInfo.rescuedPhone,
	          rescuedPlateNumber: this.dataInfo.rescuedPlateNumber.replace(/\s+/g, ''),
	          rescuedPoints: this.dataInfo.rescuedPoints,
          isUnderground: this.dataInfo.isUnderground,
          identifyNo: this.dataInfo.identifyNo,
          policyNo: this.dataInfo.policyNo,
          employeeNo: this.dataInfo.employeeNo,
          wechatOrderCause: this.dataInfo.wechatOrderCause
	        }
	        if (!this.dataInfo.evaluateStatus) {
	          delete param1.evaluateStatus
	        }
	        if (this.dataInfo.rescueStatus != 4) {
	          delete param1.cancelReason
	          delete param1.cancelStatus
	        }
	        this.saveEdit(param1)
	      } else { // 新建保存
	        let param2 = {
	          dateType: this.dataInfo.dateType,
	          requestTime: this.dataInfo.requestTime,
	          rescueStage: this.dataInfo.rescueStage,
	          rescueStatus: 1,
	          rescueType: this.dataInfo.rescueType,
	          evaluateRemark: this.dataInfo.evaluateRemark,
	          evaluateStatus: this.dataInfo.evaluateStatus,
	          destAddress: this.dataInfo.destAddress,
	          destAddressDetail: this.dataInfo.destAddressDetail,
	          destPoints: this.dataInfo.destPoints,
	          rescuedAddress: this.dataInfo.rescuedAddress,
	          rescuedAddressDetail: this.dataInfo.rescuedAddressDetail,
	          rescuedColor: this.dataInfo.rescuedColor.replace(/\s+/g, ''),
	          rescuedMemo: this.dataInfo.rescuedMemo,
	          rescuedModel: this.dataInfo.rescuedModel,
	          rescuedName: this.dataInfo.rescuedName,
	          rescuedPhone: this.dataInfo.rescuedPhone,
	          rescuedPlateNumber: this.dataInfo.rescuedPlateNumber.replace(/\s+/g, ''),
	          rescuedPoints: this.dataInfo.rescuedPoints,
          isUnderground: this.dataInfo.isUnderground,
          identifyNo: this.dataInfo.identifyNo,
          policyNo: this.dataInfo.policyNo,
          employeeNo: this.dataInfo.employeeNo,
          wechatOrderCause: this.dataInfo.wechatOrderCause
	        }
	        if (!this.dataInfo.evaluateStatus) {
	          delete param2.evaluateStatus
	        }
	        this.saveNew(param2)
	      }
	    },
	    saveEdit (param) { // 编辑保存
	      if (!this.clickable) {
	        return
	      }

	      this.loadingorder = true
	      this.$http.put(process.env.API_INSURANCE_ROOT + '/rescue-api/orders', param, {emulateJSON: true}).then(res => {
	        if (res.data.success) {
	          this.loadingorder = false
						// 关闭当前tab并自动刷新一览表格
	          this.closeAndRefresh()
						// 更新监控平台定位
	          this.adjustRescueAdd()
	        }
	      }, res => {
	        this.loadingorder = false
	        this.showWithdraw = false
	        if (res.body.message == '') {
	          this.openMsgTip('请求出问题啦，请稍后重试')
	        } else {
	          this.openMsgTip(res.data.message)
	        }
	      }).catch(res => {
	        this.loadingorder = false
	        this.showWithdraw = false
	        this.openMsgTip(OPERATE_EXCEPTION)
	      })
	    },
	    saveNew (param) { // 新建保存
	      if (!this.clickable) {
	        return
	      }
	      this.loadingorder = true
	      this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/orders', param, {emulateJSON: true}).then(res => {
	        if (res.data.success) {
	          this.loadingorder = false
						// 关闭当前tab并自动刷新一览表格
	          this.closeAndRefresh()
	        }
	      }, res => {
	        this.loadingorder = false
	        this.showWithdraw = false
	        this.openMsgTip(res.data.message)
	        if (res.body.message == '') {
	          this.openMsgTip('请求出问题啦，请稍后重试')
	        }
	      }).catch(res => {
	        this.loadingorder = false
	        this.showWithdraw = false
	        this.openMsgTip(OPERATE_EXCEPTION)
	      })
	    },
			// 保存后，将救援单定位到地图或修改定位信息
	    adjustRescueAdd () {
	      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/locating/' + this.dataInfo.id).then(res => {
	        const info = {
	          resInfo: res.body.data,
	          uni: new Date().getTime()
	        }
	        this.$store.dispatch('dataFromRescue', info) // 更新监控平台定位
	      }, res => {
	        this.showWithdraw = false
	        this.openMsgTip(res.body.message)
	        if (res.body.message == '') {
	          this.openMsgTip('请求出问题啦，请稍后重试')
	        }
	      }).catch(res => {
	        this.showWithdraw = false
	        this.openMsgTip(OPERATE_EXCEPTION)
	      })
	    },
			// 关闭当前窗口，刷新一览页面
	    closeAndRefresh () {
	      let navList = this.$store.state.home.tabList
	      let tmpObj = navList.find(n => n.id == 'PageRescueServiceOrderList')
	      let curIndex = navList.findIndex(n => n.route == this.$route.path)
	      if (!tmpObj) { // 跳转到监控平台
	        this.$store.dispatch('closeDetailTab', {index: curIndex, route: '/indexhome'})
        this.$router.push('/indexhome')
               /* let info = this.dataInfo
                const param = {
					resInfo:info,
					uni:new Date().getTime()
				}
				this.$store.dispatch('dataFromRescue',param) //更新监控平台定位 */
	      } else {
	        this.$store.dispatch('closeDetailTab', {index: curIndex, route: '/indexhome/rescueServiceOrderList'})
        this.$router.push('/indexhome/rescueServiceOrderList')
        this.$store.dispatch('refreshOrderList', true)
	      }
	    },
			// 撤单--------------------
	    cancelOrder () {
	      this.$refs.cancelOrderModal.open()
	      classlist.toggleScroll('close', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	      this.firstStep = true
	      this.showMsg = false
	    },
	    confirmCancel () {
	      if (this.firstStep) {
	        if (this.killOrderReason == '') {
	          this.showMsg = true
	          return
	        } else {
	          this.showMsg = false
	        }
	        this.firstStep = false
	      } else {
	        let param = {
	          cancelReason: this.killOrderReason,
	          cancelStatus: this.killOrderStatus,
	          rescueStage: this.killOrderStatus,
	          rescueStatus: this.dataInfo.rescueStatus
	        }
	        this.$http.put(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/' + this.dataInfo.id + '/cancel', param, {emulateJSON: true}).then(res => {
						// 如果撤单成功
	          this.$refs.cancelOrderModal.close()
	          classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	          this.firstStep = true
						// 关闭当前tab并自动刷新一览表格
	          this.closeAndRefresh()
	        }, res => {
	          this.showWithdraw = false
	          if (res.body.message == '') {
	            this.openMsgTip('本次撤单失败，请稍后重试')
	          } else {
	            this.openMsgTip(res.data.message)
	          }
	          this.$refs.cancelOrderModal.close()
	          classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	        })
					/* .catch(res=>{
						this.showWithdraw = false
						this.openMsgTip('请求异常')
						this.$refs.cancelOrderModal.close()
						classlist.toggleScroll('open','#rescueserviceorder-edit' + this.dataInfo.id,this);
					}) */
	      }
	    },
	    closeCancelM () {
	      if (this.firstStep) {
	        this.$refs.cancelOrderModal.close()
	        classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	      } else {
	        this.firstStep = true
	      }
	    },
			// 删除-----------------------
	    delOrder () {
	      this.$http.delete(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/' + this.dataInfo.id).then(res => {
				 	this.showWithdraw = false
	        this.openMsgTip('救援单删除成功')
					// 关闭当前tab并自动刷新一览表格
	        this.closeAndRefresh()
	      }, res => {
	        this.showWithdraw = false
	        if (res.body.message == '') {
	          this.openMsgTip('本次救援单删除失败，请稍后重试')
	        } else {
	          this.openMsgTip(res.data.message)
	        }
	      }).catch(res => {
	        this.showWithdraw = false
	        this.openMsgTip(OPERATE_EXCEPTION)
	      })
	    },
			// 【人保四期】新增：人保坐席派单给救援公司
	    dispatchToCompany () {
				// 拉取救援公司数据
	      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/account/customer/fleet').then(res => {
	        let result = res.body.data
	        if (result.length === 0) {
	          this.closeDispatchM()
	          this.openMsgTip('系统暂无可用的救援公司')
	          return
	        }
					// 打开弹框
					this.btnLoading = false
					this.$refs.dispatchModal.open()
					classlist.toggleScroll('close', '#rescueserviceorder-edit' + this.dataInfo.id, this)
					if (this.dataInfo.rescueType === 5) {
						result.forEach(item => {
							if (item.groupName === '东方华安') {
								this.otherId = item.id
								this.otherGroupName = item.groupName
							}
						})
					} else {
						this.rescueCompanys = result	
					}
	      }, res => {
	        if (res.body.message == '') {
	          this.openMsgTip('获取救援公司失败，请稍后重试')
	        } else {
	          this.openMsgTip(res.data.message)
	        }
	      })
				/* .catch(res=>{
					this.openMsgTip('拉取救援公司信息失败')
				}) */
	    },
			confirmDispatchM () { // 确定向救援公司派单
				this.btnLoading = true
	      this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/dispatch/' + this.dataInfo.id + '/companyId/' + this.selRescueCorpId).then(res => {
	        this.closeDispatchM()
					// 2，在向救援公司派单后面添加已派单详情,即刷新该页面
	        this.initOrderForm(this.dataInfo.id)
	      }, res => {
				//	this.closeDispatchM()
	        if (res.body.message == '') {
	          this.openMsgTip('本次派单失败，请稍后重试')
	        } else {
	          this.openMsgTip(res.data.message)
					}
					this.btnLoading = false
	      })
				/* .catch(res=>{
					this.openMsgTip('系统派单失败')
					this.$refs.dispatchModal.close()
					classlist.toggleScroll('open','#rescueserviceorder-edit' + this.dataInfo.id,this);
				}) */
	    },
	    closeDispatchM () { // 取消向救援公司派单
	      this.$refs.dispatchModal.close()
	      classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    },
			// v2.4.0新增-客服评价部分修改
	    toComment () { // 点击客服评价-弹出评价弹框
	      this.$refs.commentModal.open()
	      classlist.toggleScroll('close', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    },
	    setRemark (num) { // 客服评价
	      this.customerServiceEvaluateStatus = num
	    },
	    confirmComment () { // 点击提交评价
	      this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/service/evaluate', {
	        customerServiceEvaluateREMARK: this.customerServiceEvaluateREMARK,
	        customerServiceEvaluateStatus: this.customerServiceEvaluateStatus,
	        orderId: this.dataInfo.id
	      }).then(res => {
	        this.stopComment()
					// 提交评价成功后，刷新页面
	        this.initOrderForm(this.dataInfo.id)
	      }, res => {
	        if (!res.body.message) {
	          this.openMsgTip('提交评价失败，请稍后重试')
	        } else {
	          this.openMsgTip(res.body.message)
	        }
	      })
	    },
	    stopComment () { // 取消评价
	      this.customerServiceEvaluateREMARK = ''
	      this.customerServiceEvaluateStatus = ''
	      this.$refs.commentModal.close()
	      classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    },
		//内部调度
		changescheduling(){
			this.availserror = ''
			this.$refs.schedulingModal.open()
			this.listavailable()
	      	classlist.toggleScroll('close', '#rescueserviceorder-edit' + this.dataInfo.id, this)
		},
		//取消内部调度
		closeschedulingModal(){
		  this.$refs.schedulingModal.close()
	      classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
		},
		//可以调度的司机
		listavailable(){
			let that = this
			this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/'+this.dataInfo.id+'/driver/available').then(res => {
				if(res.body.code == 200){
					that.availableList = res.body.data
				}else{
					this.openMsgTip(res.data.message)
				}
			}, res => {
				this.openMsgTip(res.data.message)
			})
		},
		changeavailable(val){
			
		},
		//确认内部调度
		confimscheduling(){
			if(this.availableModel == ''){
				this.availserror = '请选择变更司机'
				return false
			}else{
				this.availserror = '请选择变更司机'
			}
			this.showWithdraw = true
			let splicId = this.availableModel.split('、')
			let param = {
				orderId:this.dataInfo.id,
				driverId:parseInt(splicId[0]) ,
				vehicleId:parseInt(splicId[1]) 
			}
			this.$http.put(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/modify/rescueDriver', param).then(res => {
				this.showWithdraw = false
				if(res.data.code == 200){
	          		this.openMsgTip('内部调度成功')
					// 2，关闭当前tab并自动刷新一览表格
					this.closeAndRefresh()
				}else{
	          		this.openMsgTip(res.data.message||'内部调度更改失败')
				}
			  
	        }, res => {
	          this.showWithdraw = false
	          if (res.body.message == '') {
	            this.openMsgTip('内部调度更改失败，请稍后重试')
	          } else {
	            this.openMsgTip(res.data.message)
	          }
	        }).catch(res => {
	          this.showWithdraw = false
	          this.openMsgTip(res.data.message)
	        })	
		},
		//变更救援类型
		changeRescue(){
			this.changeDestination = ''
	      	this.changedestPoints = ''
			this.chrescueType = ''
			this.chreserror = ''
			this.desterror = ''
			this.$refs.changeRescueModal.open()
	      	classlist.toggleScroll('close', '#rescueserviceorder-edit' + this.dataInfo.id, this)
		},
		//取消变更救援
		closeRescueModal(){
		  this.$refs.changeRescueModal.close()
	      classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
		},
		//确定变更救援
		confimRescue(){
			if(this.chrescueType == ''){
				this.chreserror = '请选择变更救援类型'
				return false
			}else{
				this.chreserror = ''
			}
			if(this.chrescueType === '1'){
				if(this.changeDestination == ''){
					this.desterror = '请输入目的地变更地址'
					return false
				}else{
					this.chreserror = ''
				}
			}
			
			this.showWithdraw = true
			let isUnderground
			if(this.chrescueType == 4){
				this.chrescueType = 1
				isUnderground = 1
			}else{
				isUnderground = 0
			}
			let param = {
	          destAddress: this.changeDestination,
	          destPoints: this.changedestPoints,
	          orderId: this.dataInfo.id,
			  rescueType:this.chrescueType,
			  isUnderground:isUnderground  //是否是地库拖车 0-否，1-是 
	        }
	        this.$http.put(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/modify/rescueType', param).then(res => {
	          this.showWithdraw = false
			  if(res.data.code == 200){
				this.openMsgTip('变更救援类型成功')
				// 2，关闭当前tab并自动刷新一览表格
				this.closeAndRefresh()
			  }else{
				this.openMsgTip(res.data.message||'变更救援类型更改失败')
			  }
	         
	        }, res => {
	          this.showWithdraw = false
	          if (res.body.message == '') {
	            this.openMsgTip('变更救援类型更改失败，请稍后重试')
	          } else {
	            this.openMsgTip(res.data.message)
	          }
	        }).catch(res => {
	          this.showWithdraw = false
	          this.openMsgTip(res.data.message)
	        })	
		},
			// 改变救援状态相关---------------
	    dispatchChange (type) { // 改变派单方式   11-自动派单  12-人工派单
	      let typeStr = ''
	      if (type == 11) {
	        typeStr = '自动'
	      } else {
	        typeStr = '人工'
	      }
	      this.showWithdraw = true
	      this.openMsgTip('您将要将当前救援单改为' + typeStr + '派单，您确定要继续吗？')
	    },
	    closeMsgTip () { // 提示弹框-取消按钮
	      this.showWithdraw = false
	      this.$refs.modalMsg.close()
	      classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    },
	    confirmMsgTip () {
	      if (this.showWithdraw) { // 提示确认改变派单方式时
					// 1，切换派单方式--人工或自动
	        let param = {
	          cancelReason: '',
	          cancelStatus: '',
	          rescueStage: this.dataInfo.rescueStage == 11 ? 12 : 11  // 指切换后的派单方式，如果当前为2（自动派单），切换成12（人工派单）
	        }
	        this.$http.put(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/modify/' + this.dataInfo.id, param, {emulateJSON: true}).then(res => {
	          this.showWithdraw = false
	          this.openMsgTip('派单方式更改成功')
					// 2，关闭当前tab并自动刷新一览表格
	          this.closeAndRefresh()
	        }, res => {
	          this.showWithdraw = false
	          if (res.body.message == '') {
	            this.openMsgTip('本次派单方式更改失败，请稍后重试')
	          } else {
	            this.openMsgTip(res.data.message)
	          }
	        }).catch(res => {
	          this.showWithdraw = false
	          this.openMsgTip(res.data.message)
	        })
	      }
	      this.$refs.modalMsg.close()
	      classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    },
			// 查看救援车位置---打开“救援监控平台”功能，将当前救援车辆拉至地图中间信息。
	    checkPos () {
				// 1,跳转到监控平台
	      const obj = {
	        name: '救援服务平台',
	        code: 'vehicleMonitor',
	        id: 'PageVehicleMonitor',
	        route: '/indexhome',
	        No: 'vehicleMonitor'
	      }
	      this.$router.push(obj.route)
	      this.$store.dispatch('addTab', obj)
			// 2，定位
	      this.$store.dispatch('locateOne', this.dataInfo.vehicleId)
	    },
			// 取消重新派单
	    reDispatch () {
	      this.$refs.reDispatchModal.open()
	      classlist.toggleScroll('close', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    },
	    autoReDispatch () { // 自动重派
	      let param = {
	        cancelReason: this.reSendReason,
	        cancelStatus: this.reSendStatus,
	        rescueStage: 11
	      }
	      this.switchDispatchWay(param)
	    },
	    handReDispatch () { // 人工重派 【人保四期】，救援公司传13，人保坐席传12
	      let param = {
	        cancelReason: this.reSendReason,
	        cancelStatus: this.reSendStatus,
	        rescueStage: this.levv == 3 ? 13 : 12
	      }
	      this.switchDispatchWay(param)
	    },
	    switchDispatchWay (param) {
	      this.$http.put(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/modify/' + this.dataInfo.id, param, {emulateJSON: true}).then(res => {
	        this.showWithdraw = false
	        this.openMsgTip('重新派单成功')
				// 关闭当前tab并自动刷新一览表格
	        this.closeAndRefresh()
	      }, res => {
	        this.showWithdraw = false
	        if (res.body.message == '') {
	          this.openMsgTip('重新派单失败，请稍后重试')
	        } else {
	          this.openMsgTip(res.data.message)
	        }
	      })
				/* .catch(res=>{
					this.showWithdraw = false
					this.openMsgTip(res.data.message);
				}) */
	    },
	    closeReDispatch () { // 关闭重派弹框
	      this.$refs.reDispatchModal.close()
	      classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    },
			// 提示弹框相关-------------
	    openMsgTip (message) {
	      this.tipContent = message
	      this.$refs.modalMsg.open()
	      classlist.toggleScroll('close', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    },
			// 救援地址提示相关TODO:------------
	    ready (obj) {
	      const {map, BMap} = obj
	      this.map = map
	      this.BMap = BMap
	    },
		//输入目的地变更地址
		destinationAdds(){
			this.loadingBtdest = true
			this.changeDestination = ''
	      	this.changedestPoints = ''
			var ac = this.searchCommon('newdestination', 'newdestinationPanel')
			var myValue
			let self = this
			ac.addEventListener('onconfirm', function (e) {    // 鼠标点击下拉列表后的事件
				var _value = e.item.value
				myValue = _value.province + _value.city + _value.district + _value.street + _value.business
				if (self.isDetailMode) {
				G('srchPanelRescue' + self.dataInfo.id).innerHTML = 'onconfirm<br />index = ' + e.item.index + '<br />myValue = ' + myValue
				} else {
				G('newSrchPanelRescue').innerHTML = 'onconfirm<br />index = ' + e.item.index + '<br />myValue = ' + myValue
				}
				self.setDilogPlace(myValue,1)
			})
		},
			// 输入救援地址
	    searchRescueAdds () {
	      this.loadingBtn1 = true
	      this.dataInfo.rescuedPoints = ''
	      this.dataInfo.rescuedAddress = ''
	      if (this.isDetailMode) {
	        var ac = this.searchCommon('srchInputRescue' + this.dataInfo.id, 'srchPanelRescue' + this.dataInfo.id)
	      } else {
	        var ac = this.searchCommon('newSrchInputRescue', 'newSrchPanelRescue')
	      }
	      var myValue
	      let self = this
	      ac.addEventListener('onconfirm', function (e) {    // 鼠标点击下拉列表后的事件
	        var _value = e.item.value
	        myValue = _value.province + _value.city + _value.district + _value.street + _value.business
	        if (self.isDetailMode) {
	          G('srchPanelRescue' + self.dataInfo.id).innerHTML = 'onconfirm<br />index = ' + e.item.index + '<br />myValue = ' + myValue
	        } else {
	          G('newSrchPanelRescue').innerHTML = 'onconfirm<br />index = ' + e.item.index + '<br />myValue = ' + myValue
	        }
	        self.setPlace(myValue,1)
	      })
	    },
			// 输入目的地址
	    searchDestAdds () {
	      this.loadingBtn2 = true
	      this.dataInfo.destPoints = ''
	      this.dataInfo.destAddress = ''
	      if (this.isDetailMode) {
	        var ac = this.searchCommon('srchInputDest' + this.dataInfo.id, 'srchPanelDest' + this.dataInfo.id)
	      } else {
	        var ac = this.searchCommon('newSrchInputDest', 'newSrchPanelDest')
	      }
	      var myValue
	      let self = this
	      ac.addEventListener('onconfirm', function (e) {    // 鼠标点击下拉列表后的事件
	        var _value = e.item.value
	        myValue = _value.province + _value.city + _value.district + _value.street + _value.business
	        if (self.isDetailMode) {
	          G('srchPanelDest' + self.dataInfo.id).innerHTML = 'onconfirm<br />index = ' + e.item.index + '<br />myValue = ' + myValue
	        } else {
	          G('newSrchPanelDest').innerHTML = 'onconfirm<br />index = ' + e.item.index + '<br />myValue = ' + myValue
	        }
	        self.setPlace(myValue, 2)
	      })
	    },
	    searchCommon (id, resId) {
	      const {map, BMap} = this
	      console.log(map)
	      const that = this
	      var ac = new BMap.Autocomplete(    // 建立一个自动完成的对象
	        {
	          'input': id,
	          'location': map,
	          onSearchComplete: function () {
	            if (that.disposeAutoComplete) {
	              ac.hide()
	              that.disposeAutoComplete = false
	            }
	          }
	        })
	      ac.addEventListener('onhighlight', function (e) {  // 鼠标放在下拉列表上的事件
	        var str = ''
        var _value = e.fromitem.value
	        var value = ''
        if (e.fromitem.index > -1) {
	          value = _value.province + _value.city + _value.district + _value.street + _value.business
	        }
	        str = 'FromItem<br />index = ' + e.fromitem.index + '<br />value = ' + value

	        value = ''
        if (e.toitem.index > -1) {
	          _value = e.toitem.value
	          value = _value.province + _value.city + _value.district + _value.street + _value.business
	        }
	        str += '<br />ToItem<br />index = ' + e.toitem.index + '<br />value = ' + value
	        G(resId).innerHTML = str
	      })
	      return ac
	    },
		//弹窗变更救援类型中的地址检索
		setDilogPlace(myValue, type){
		  const {map} = this
	      map.clearOverlays()    // 清除地图上所有覆盖物
	      const that = this
	      var myFun = function () {
	        let resObj = local.getResults().getPoi(0)
	        if (!resObj) {
	          that.openMsgTip('地图定位失败，请重新输入或换个相邻地址')
	          return
	        }
	        var pp = local.getResults().getPoi(0).point    // 获取第一个智能搜索的结果
	        map.centerAndZoom(pp, 18)
	        let marker = new BMap.Marker(pp)
	        map.addOverlay(marker)
	        let pts = {lng: pp.lng, lat: pp.lat}
	        if (type == 1) {
			  that.loadingBtdest = false
	          that.changedestPoints = JSON.stringify(pts)
	        } 	
	      }
	      var local = new BMap.LocalSearch(map, { // 智能搜索
	        onSearchComplete: myFun
	      })
	      local.search(myValue)
	      if (type == 1) {
	        this.changeDestination = myValue
	      } 
	      this.gpsSource = 0
		},
	    setPlace (myValue, type) { // 地址检索时调用的方法
	      const {map} = this
	      map.clearOverlays()    // 清除地图上所有覆盖物
			/* if(type==1){
				this.loadingBtn1 = true
				this.dataInfo.rescuedPoints = ''
			}else{
				this.loadingBtn2 = true
				this.dataInfo.destPoints = ''
			} */
	      const that = this
	      var myFun = function () {
	        let resObj = local.getResults().getPoi(0)
	        if (!resObj) {
	          that.openMsgTip('地图定位失败，请重新输入或换个相邻地址')
	          return
	        }
	        var pp = local.getResults().getPoi(0).point    // 获取第一个智能搜索的结果
	        map.centerAndZoom(pp, 18)
	        let marker = new BMap.Marker(pp)
	        map.addOverlay(marker)
	        let pts = {lng: pp.lng, lat: pp.lat}
	        if (type == 1) {
	          that.loadingBtn1 = false
	          that.dataInfo.rescuedPoints = JSON.stringify(pts)
	        } else {
	          that.loadingBtn2 = false
	          that.dataInfo.destPoints = JSON.stringify(pts)
	        }
			
	      }
	      var local = new BMap.LocalSearch(map, { // 智能搜索
	        onSearchComplete: myFun
	      })
	      local.search(myValue)
	      if (type == 1) {
	        this.dataInfo.rescuedAddress = myValue
	      } else {
	        this.dataInfo.destAddress = myValue
	      }
	      this.gpsSource = 0
	    },
			// 定位页面相关----------------
	    openMapTab (pts, ads, type) { // 打开定位页面
	      this.locPoints = pts
	      this.locAddress = ads
	      this.locType = type
	      this.openLocate = true
	      classlist.toggleScroll('close', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    },
	    saveNewPos (obj) { // 获取拖拽后的地址信息
			//	console.log(obj)
	      this.gpsSource = 1
	      if (obj.type == 1) {
	        this.dataInfo.rescuedAddress = obj.address
	        this.dataInfo.rescuedPoints = JSON.stringify(obj.points)

				//	this.loadingBtn1 = false;
	      } else {
	        this.dataInfo.destAddress = obj.address
	        this.dataInfo.destPoints = JSON.stringify(obj.points)
				//	this.loadingBtn2 = false;
	      }
	      this.disposeAutoComplete = true
	      this.openLocate = false
	      classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    },
	    closeLocate () { // 不保存直接关闭
	      this.openLocate = false
	      classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    },
	    closeConfirm () { // 不保存直接关闭
	      this.showConfirm = false
	      classlist.toggleScroll('open', '#rescueserviceorder-edit' + this.dataInfo.id, this)
	    },
			// 获取udc数据-------------------
	    getUdc () {
	      let udcType = ['RESCUE_TYPE', 'RESCUE_STAGE', 'COLOR', 'EVALUATE_STATUS', 'DATE_TYPE']
	      let param = udcType.join(',')
	      this.$http.get(process.env.API_ROOT + '/system/udcs/license/2', {params: {udcTypes: param}, headers: this.token}).then(res => {
	        if (res.data.success) {
	          if (this.isDetailMode) {
	            this.loadingorder = false
	          }
	          let obj = res.body.data
	          this.evaluateStatusList = obj.EVALUATE_STATUS
	          this.rescueStageList = obj.RESCUE_STAGE
	          this.dateTypeList = obj.DATE_TYPE
	          this.rescueTypeList = obj.RESCUE_TYPE
	          this.rescueTypeList.push({
	            udccode: 4,
	            udcname: '地库拖车'
	          })
					//	let tmpI = this.rescueTypeList.findIndex(n=>n.udcname == '拖车')
					//	this.trackUdccode = this.rescueTypeList[tmpI].udccode
	        } else {
	          if (this.isDetailMode) {
	            this.loadingorder = false
	          }
	          this.showWithdraw = false
	          this.openMsgTip(res.data.message)
	        }
	      }, res => {
	        if (this.isDetailMode) {
	          this.loadingorder = false
	        }
	        this.showWithdraw = false
	        this.openMsgTip(res.data.message)
	        if (res.body.message == '') {
	          this.openMsgTip('请求出问题啦，请稍后重试')
	        }
	      }).catch(res => {
	        if (this.isDetailMode) {
	          this.loadingorder = false
	        }
	        this.showWithdraw = false
	        this.openMsgTip('请求异常')
	      })
	    },
	    getCurDate () {
	      let dtCur = new Date()
	      let yearCur = dtCur.getFullYear()
	      let monCur = dtCur.getMonth() + 1
	      let dayCur = dtCur.getDate()
	      let hCur = dtCur.getHours()
	      let mCur = dtCur.getMinutes()
	      let sCur = dtCur.getSeconds()
	      let timeCur = yearCur + '-' + (monCur < 10 ? '0' + monCur : monCur) + '-' +
			    (dayCur < 10 ? '0' + dayCur : dayCur) + ' ' + (hCur < 10 ? '0' + hCur : hCur) +
			    ':' + (mCur < 10 ? '0' + mCur : mCur) + ':' + (sCur < 10 ? '0' + sCur : sCur)
	      return timeCur
	    }
	  }
	}
	function G (id) {
	  return document.getElementById(id)
}
</script>
<style scoped lang="scss">
/*和派单详情、救援单详情切换有关*/
	ul li {
		float: left;
		padding: 5px 10px;
		list-style: none;
	}

	ul {
		border: 1px solid #ccc;
	}

	li {
		border-right: 1px solid #ccc;
	}

	li.active {
		background-color: #000;
	}
/*派单详情状态相关*/
	.red_bg{
		background-color:rgba(201,9,1,0.3)!important;
		color:#f44336;
	}
	.green_bg{
		background-color:#DDFFDC!important;
		color:#309c34;
	}
	.yellow_bg{
		background-color:#FDF7DC!important;
		color:#ef6c00;
	}
	.dioArrtxt{
		text-align: right;
		margin-right: 70px;
	}

</style>



// WEBPACK FOOTER //
// PageRescueServiceOrderEdit.vue?6ed1d6b7